import React, { Component } from 'react'
import * as queryString from 'query-string'

class Terms extends Component {
  constructor(props) {
    super(props)
    const { id, orderData } = queryString.parse(this.props.location.search)
    this.state = {
      id: id,
      orderData: orderData
        ? JSON.parse(orderData)
        : {
            userInfo: {},
            orderInfo: {},
            platform: {},
            franchise: {},
            bikeAgent: null,
            dcAgent: null,
          },
    }
  }

  render() {
    const { orderData } = this.state
    return (
      <div className='Terms' style={{ padding: '3%' }}>
        {this.state.id === 't1' && (
          <div
            id='t1'
            dangerouslySetInnerHTML={{
              __html: `<h3 style="text-align: center;">免责条款</h3><p><br/></p><h5 style="margin: 0px; padding: 0px;">平台权利和义务</h5><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、平台基于互联网，包含以云马租车平台网站、小程序等在内的各种形态（包括未来技术发展出现的新的服务形态）向用户提供租赁物及租赁管理服务工作，包括但不限于发布租赁标的或服务，对租赁标的或服务进行评价管理， 对租赁标的进行物联网管控，并妥善处理或协助处理平台上有关的交易纠纷等。<br/>2、平台可提供商家联系方式，由商家提供车辆保养、维修网点服务。保证合理使用中出现的厂家三包范围内故障维修、具体维修费用及权益和购买新车的售后权益一致。日常使用中因损耗产生的更换小零件、易耗品（如更换刹车片）等由商家负责。<br/>3、车辆外观及人为因素损坏的配件等，由用户自行承担责任，平台可提供商家联系方式，=由商家提供更换维修服务，但更换或维修产生的费用，由用户自行承担。<br/>4、平台不承担由用户使用租赁车辆引发的连带责任和用户使用过程中人员交通意外损害赔偿责任及本合同规定的风险赔付范围之外的任何经济责任。</p><p><br/></p><h5 style="margin: 0px; padding: 0px;">用户权利和义务</h5><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、认真的检查并掌握租赁车辆的各种性能和操作方法，点清随车配置的附件，验收签字后驶离。凡因用户操作不当、保管不善造成的车辆遗失换造成附件损坏，用户应向平台赔偿。<br/>2、租赁期间，发生的电动车驾驶人员伤亡事故、交通事故等与平台无关，所造成的全部经济损失由用户承担。<br/>3、用户租赁期间，发生车辆丢失，用户应承担丢失车辆的赔偿责任。电池如发生丢失，用户应赔偿平台的损失，每组电池按4000元赔偿。<br/>4、用户租赁期间通过飞熊租赁小程序购买保险服务，如发生车辆丢失，用户不承担丢失车架的赔偿责任。如电池丢失，电池按1000元每组赔偿，需用户提供报案证明。<br/>5、用户禁止打开电池盒，如发现私自打开电池盒更换电池行为，每组电池按600元进行罚款。<br/>6、使用租赁车辆应遵守相关法律、法规，因违法、违纪、违章所造成的法律责任，自行负责，并承担驾驶过程中因自身驾驶责任造成的车辆损失。<br/>7、用户必须按照约定的时间、地点归还车辆，还车时必须保证车辆性能良好、车辆整洁、设备齐全，并无任何刮碰现象。<br/>8、用户不得私配甲方出租车辆的钥匙。若造成车辆丢失、损坏等情况必须立即通知平台，并负责赔偿修配所租车辆门锁和点火开关的费用。</p><p><br/></p>`,
            }}
          ></div>
        )}
        {this.state.id === 't2' && (
          <div
            id='t2'
            dangerouslySetInnerHTML={{
              __html: `<h3 style="text-align: center;">失信危害</h3><p><br/></p><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2018年，国家多部门频频签暑联合惩戒备忘录，并推出多项联合惩治措施，失信被执行人变得寸步难行。2019年，国家将加大对失信被执行人的惩治力度，不仅失信被执行人个人受限，连其家人也要受到限制，可谓“一人失信，全家遭殃”。 失信被执行人将受到哪些限制</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">1、唯一住房法院可拍卖</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">根据《最高人民法院关于人民法院办理执行异议和复议案件若干问题的规定》第二十条的规定，符合条件，唯住房仍然可以执行，而且实务中，已经出现了大量执行唯一住房的案例，以后肯定会越来越多。<br/>比如说，被执行人50岁，其子25岁且有房产，即便被执行人只有一套房屋，也可以被执行;<br/>被执行人名下只有一套100平方米的房屋，申请执行人按照廉租房标准，为被执行人提供一套小面积房屋，用于维持其生活必需，那么被执行人名下这套100平方米的房屋就可以被执行<br/>申请执行人按照当地平均租房价格，为被执行人提供5到8年的租房费用，则被执行人名下这套100平方米的房屋也可以被执行。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">2、虚拟账户法院可查封、冻结</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">支付宝、移动支付、微信支付等网络虚拟交易账户中的资金，也属于法院可执行的被执行人财产范围。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">3、法院可网上冻结、划扣失信被执行人财产</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2016年2月起，人民法院和金融机构将通过网络方式发送电子法律文书，接收金融机构查询、冻结、扣划、处置等的结果数据和电子回执。 执行法官足不出户，鼠标一点就能对被执行人在全国4000多家银行业金融机构的金融财产查得到、冻得住、扣得了</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">4、限制支付宝，芝麻信用等网络支付工具和授信</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2015年7月24日，最高法与芝麻信用签署对失信被执行人信用惩戒合作备忘录，最高人民法院官方授权第三方商业征信机构通过互联网联合信用惩戒。 芝麻信用会同淘宝、天描、神州租车、趣分期、去哪儿旅游、我爱我家相寓等各应用平台在消费金融、云马小贷、信用卡、P2P、酒店、租房、租车等场景全面限制失信被执行人，压缩失信被执行人生存空间。主要措施有:限制失信被执行人申请货款、融资等金融行为;限制失信被执行人通过淘宝或天猫平台购买机票、列车软卧、保险理财产品及非经营必需车辆、旅游、度假产品等;限制预定.星级以上宾馆、酒店;限制失信被执行人在互联网的奢侈品交易等高消费行为。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">5、不能担任企业的法定代表人、董事、监事、高级管理人员等</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2014年3月中央文明办、最高人民法院、公安部、国务院国资委、国家工商总局、中国银监会、中国民用航空局、中国铁路总公司关于印发《“构建诚信惩戒失信”合作备忘录》的通知(文明办[201414号)，明确失信被执行人为自然人的，不得担任企业的法定代表人、董事、监事、高级管理人员等。《关于加快推进失信被执行人信用监督警示和惩戒机制建设的意见》中用的是“限制”，当然也包括禁止。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">6、禁止失信被执行人上高速</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2015年1月，重庆市高级人民法院联合重庆高速执法支队在重庆市高速路部分主线收费站严查失信被执行人，失信被执行人的车辆只要行驶上了高速，就将被现场扣留，由高速执法移交法院处理。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">7、限制乘坐火车、飞机!</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2018年5月1日，发改委、铁路总公司、民航局等部门联合发布意见。意见指出，在一定期限内适当限制特定严重失信人乘坐火车，在一定期限内适当限制特定严重失信人乘坐民用航空器。 不仅如此!意见甚至细化到了具体行为。其中，行为责任人发生在动车上吸烟等4种行为，各铁路运输企业限制其购买车票，有效期为180天。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">8、限制高消费</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">根据2015年7月22日起施行《最高人民法院关于限制被执行人高消费及有关消费的若干规定》第三条规定，限制如下高消费:乘坐交通工具时，选择飞机、列车软卧轮船二等以上舱位;在星级以上宾馆、酒店、夜总会、高尔夫球场等场所进行高消费;购买不动产或者新建、扩建、高档装修房屋;租赁高档写字楼、宾馆、公寓等场所办公;购买非经营必需车辆;旅游、度假;子女就读高收费私立学校;支付高额保费购买保险理财产品;乘坐G字头动车组列车全部座位、其他动车组列车一等以上座位等其他非生活和工作必需的消费行为。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">9、限制失信被执行人炒股、买房、出境</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">由国家发展改革委和最高人民法院牵头，人民银行中央组织部等44家单位联合签署的《关于对失信被执行人实施联合惩戒的合作备忘录》对外发布。备忘录限制失信被执行人炒股、出境及购买不动产等。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">10、被执行人养老金可被划扣</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">2014年6月24日，最高人民法院《关于能否要求社保机构协助冻结、扣划被执行人的养老金问题的复函》(2014)执他字第22号，明确确认社会保障机构作为养老金发放机构，有乂务协助人民法院冻结、扣划被执行人应得的养老金。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">11、失信被执行人最高可判7年</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">《刑法修正案(九)》第三十九规定:“对人民法院的判決、裁定有能力执行而拒不执行，情节严重的，处三年以下有期徒刑、拘役或者罚金;情节特别严重的，处三年以上七年以下有期徒刑，并处罚金。 一个人活在社会上，最基本的就是“衣、食、住行”，而从上可看出，一旦失信，将无法乘高铁、坐飞机、买房、消费，甚至工作中涉及招标投标也被受限。来到2019年，连其家人也将受到限制。 这些情况，将产生不良记录!<br/>◆信用卡连续三次(或两年内累计六次)逾期还款<br/>◆房货、车货月供累计2至3个月逾期或不还款<br/>◆逾期借款利率上调，仍按原金額支付“月供”，产生欠息逾期<br/>◆睡眠信用卡激活后不使用也会有年费，不缴纳可能产生负而信用记录<br/>◆信用卡透支消费、按揭货款没有及时按期还款<br/>◆为第三方提供担保时，第三方没有按时偿还贷款<br/>◆欠账等经济纠纷<br/>◆水、电、燃气费不按时交教<br/>◆个人信用卡出现套现的行为<br/>◆助学贷款拖欠不还款<br/>◆手机扣费与银行卡挂钩，手机停用后欠月租费形成逾期<br/>◆被冒用身份证产生信用卡欠费记录</p><p><br/></p><h3 style="margin: 0px; padding: 0px; font-size: 16px;">二、失信被执行人家人将受到哪些限制</h3><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">1、子女不能上私立学校</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">最高人民法院关于限制被执行人高消费及有关消费的若干规定》第三条规定，被执行人为自然人的，被采取限制消费措施后，子女不得就读高收费私立学校。但请注意两个关键词“高收费”和“私立”，即如果子女就读公立学校或虽为私立学校但收费并不高，不属于限制范畴。中共中央办公厅、国务院办公厅在《关于加快推进失信被执行人信用监督、警示和惩戒机制建设的意见》中进一步明确，限制失信被执行人以其财产支付子女入学就读高收费私立学校，即如果子女就读高收费私立学校的钱不是纳入失信被执行人名单的父母出的，也不属于限制范畴 最近，河北正式打响第一枪!向衡水第一中学、衡水中学实验学校等7所私立学校发出通知，限制失信之人的子女!</p><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">通知明确载明<br/>（1）各私立学校的招生简章，需载明报名学生家长必须没有被人民法院列为失信被执行人的相关记录<br/>（2）凡被人民法院列为失信被执行人者，一律不得录取<br/>（3）对已招录学生，有上述情形者，一经发现，应责令退学或转校到公办学校</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">2、子女考大学可能被拒绝录取</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">据报道，浙江温州饶先生的儿子今年参加高考，考上了北京某知名大学。正当一家人沉浸在喜悦之中时，却接到了报考大学的通知，“我校在资格审查时发现您存在失信行为，请立即处理，否则我校将不予录取您的孩子原来，饶先生之前欠了银行20万货款至今未还，得知此事后，饶先生马上联系银行，立即还清了货款。一位一线执行法官认为，“从构建社会诚信大格局来说，对失信被执行人子女入学的相关限制，恰恰是对申请执行人权益的保护，因为失信被执行人子女上学的费用，很大程度上是拿着申请人被拖欠的费用</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">3、子女考公务员、军校、航空院校等政审无法通过</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">在公务员政审中，有一项是审查考生的直系亲属是否有刑事犯罪记录，如果直系亲属有刑事犯罪记录的，则孩子公务员政审不通过。 如果父母是失信被执行人，那也将严重影响子女公务员、军校等政审! 2018年5月24日，被执行陶某某因儿子报考航空院校，在《招飞对象及其家庭成员政治考核走访调查材料》中，要求招飞对象及其家庭成员所在地的法院出具相关证明，但由于其父母被列入失信被执行人名单，故难以通过招飞单位审查。</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">4、未成年子女名下的房产可强制执行有些失信被执行人为了躲避债务，将房产都登记在未成年子女名下，这种方法是行不通的!</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">法院会综合分析房屋购买时间、产权登记时间、负债情况及购房款的支付，认定案涉房屋所有权属于失信被执行人，就可以强制评估拍卖 前法院已经出现相关案例，强制执行被执行人未成年子女来历不明巨额财产，以后也将得到普遍认可</p><p><br/></p><h4 style="margin: 0px; padding: 0px; font-size: 14px;">5、夫妻共同房产可执行</h4><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">共同共有的房产并不能排除法院的强制执行，即使被认定为夫妻个人债务，但存在夫妻共同房产的情形下，法院也能够依法评估拍卖夫妻共同的房产!拍卖后将一半预留给夫妻一方即可。 “父债子还”“株连九族”的时代早已过去，诚信依然非常重要，也希望从你我开始，约束自己，影响他人改变世界!</p><p style="color: rgba(0, 0, 0, 0.65);font-size: 14px;">纳入法院失信被执行人名单的被执行人，将有以下消费行为限制:<br/>①乘坐交通工具时，不得选择飞机、列车软卧、轮船二等以上舱位<br/>②不得在星级以上宾馆、酒店、夜总会、高尔夫球场等场所进行高消费<br/>③不得购买不动产或者新建、扩建、高档装修房屋<br/>④不得租赁高档写字楼、宾馆、公寓等场所办公<br/>⑤不得购买非经营必需车辆<br/>⑥不得旅游、度假<br/>⑦子女不得就读高收费私立学校<br/>⑧不得支付高额保费购买保险理财产品<br/>⑨不得乘坐G字头动车组列车全部座位、其他动车组列车一等以上座位</p>`,
            }}
          ></div>
        )}
        {this.state.id === 't3' && (
          <div id='t3'>
            <div
              dangerouslySetInnerHTML={{
                __html: `<h3 style="text-align: center;">操作说明</h3><p><br/></p><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1.租赁周期：平台提供按月短租服务，租赁订单即时生效，请在租约到期前完成续租或者退租操作。<br/><br/>2.提前退租：如果您提前退租，不满1个月按1个月计算，已收取的租金不予退还。<br/><br/>3.租车有什么条件：飞熊租赁信用租，只要芝麻信用分达N值即可享受免押金服务，下单支付即可取车。<br/><br/>4.续租怎么操作：在您的订单详情中点击续租操作，支付费用后将在原来的订单中增加租赁时限。<br/><br/>5.退租怎么操作：在订单详情中点击退租操作，还车至站点，经站长验车后审核通过，完成退租。请保持车辆干净整洁。<br/><br/>6.关于逾期租金违约金：当您超出租赁约定期限未归还车辆至站点，系统将收取套餐金额*0.5‰*逾期天数的逾期租金违约金费用。<br/><br/>7.逾期有什么样的风险：平台提供的信用租基于您的征信分值，若有违约行为，将给您的征信记录带来不良影响。<br/><br/>8.保险有什么用：在您租赁期间为您的车辆提供安全保障，如有意外可向租赁车辆的站点提出申请理赔。详情请仔细阅读盗抢险服务条例。<br/><br/>9.超时后车还能用吗：如您的订单超时，系统将锁定您的车辆，同时电池也将无法使用，未免给您带来不必要的影响，请务必在租约结束前退租或者续租。</p><p><br/></p>`,
              }}
            ></div>
            <h3>租车步骤</h3>
            <br />
            <br />
            <b>注：本步骤说明金额为测试金额，具体金额以城市显示为准。</b>
            <h4>
              1.当进入飞熊租赁小程序后授权系统定位。（首先确保您手机对支付宝开通定位服务。这样小程序才能识别到您所在区域套餐）
            </h4>
            <br />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms001.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              2.租车时请谨慎选择适合您的租车套餐，点击套餐。下滑页面点击信用租。
            </h4>
            <b>
              注：租赁周期以自然月为单位，最低租赁一月。如您提前退租，将视为您自愿放弃剩余使用权。
            </b>
            <br />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms002.png')}
              alt=''
            />
            <br />
            <h4>
              <br />
              <br />
              3.在弹框页面可以查看您所选购的套餐车型、电池型号、租赁周期等信息，并且您需要在该页面选择您要租赁的站点（系统默认站点为离您现在距离最近的一个）。
              <br />
            </h4>
            <b>注：如果您发现此套餐不是您要选择的套餐，请返回到首页重新选择。</b>
            <br />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms003.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              4.在确认完套餐信息及提车点后，点击确认进行支付宝预授权审核。
              <br />
              在您审核通过时，会显示如左图，将为你减免冻结资金。如果审核没有通过会显示如右图，将会跳转到冻结页面，进行资金冻结，如下图。
            </h4>
            <b>
              注：冻结资金以及解冻资金记录可以在支付宝账单查看，冻结资金会于您结束该订单时立马解冻。冻结资金可以对支付宝余额、余额宝、花呗额度、银行卡等账户冻结，资金将冻结在您支付宝账户内，租车期间无法使用。
            </b>
            <br />
            <img
              style={{ width: '49%' }}
              src={require('@/statics/img/rerms/terms004.png')}
              alt=''
            />
            <img
              style={{ width: '49%' }}
              src={require('@/statics/img/rerms/terms005.png')}
              alt=''
            />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms006.png')}
              alt=''
            />
            <br />
            <h4>
              <br />
              <br />
              5.进行订单支付时，请自行阅读免责申明，并注意您套餐的起止日期。
            </h4>
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms007.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              6.在待提车页面，如果忘记购买保险，7天内可在保险信息栏选择“购买保险”。
              在页面下部，您可以电话咨询提车点工作人员并且通过地图找到提车点位置。
              如果您放弃提车，请点击申请退款按钮，进行退款。（申请退款将扣除套餐金额10%的手续费。）
            </h4>
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms008.png')}
              alt=''
            />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms009.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              7.如果您已经退出到首页，想要查询订单详情或购买保险。可以依序找到我的-我的订单，然后点击您进行中的订单查看详细信息及购买保险。
            </h4>
            <b>注：如果您下错提车点请联系400-081-1818售后电话，按1并转到所在城市客服。</b>
          </div>
        )}
        {this.state.id === 't4' && (
          <div
            id='t4'
            dangerouslySetInnerHTML={{
              __html: `<h3 style="text-align: center;">服务协议</h3><p><br/></p><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">出租方：镇江云马科技有限责任公司<br/><br/>承租方：</p><p><br/></p><h4 style="color: rgba(0, 0, 0, 0.85); font-size: 14px;">第一条、总则</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、本协议中整车是指车辆和电池；车辆是指裸车，不包括电池。<br/>2、服务是针对整车租赁中由于意外造成的车辆（不含电池）损失，并满足报案及理赔流程要求（下附），则承租方无需赔偿的超值保障服务。<br/>3、本协议中的服务仅适用于承租方向出租方租赁的在租赁期内的车辆和锂电池。<br/>4、服务费用在整车租赁订单确认后一次性支付到出租方指定帐号。<br/>5、整车租赁期间的丢失、被盗责任由承租方承担，与出租方无关。</p><p><br/></p><h4 style="color: rgba(0, 0, 0, 0.85); font-size: 14px;">第二条、服务使用介绍</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、承租方购买服务后，若车辆、电池丢失，并按照丢失报案及理赔流程执行，则承租方无需赔付车辆成本，而锂电池则需赔付1000元/组；若未按照丢失报案及理赔流程执行，则承租人按车辆和电池的约定成本赔付（车辆2200元/辆，锂电池4000元/组）。<br/>2、服务为一次性保障服务。即购买一次该服务，在租赁期内对应的租赁车辆、电池可获得一次保障服务。<br/>3、本服务可在整车租赁订单确认或续租时办理购买，补交保险需在下单后7天内（续租后7天内）购买。<br/>4、承租方购买服务后，在同一租赁订单内再次续租，若未启用过服务，则续租时无需重复购买服务。<br/>5、本服务仅在租赁期间内有效，即订单为租车中状态。<br/>6、退租时无论服务是否启动，服务费均不退还。</p><p><br/></p><h4 style="color: rgba(0, 0, 0, 0.85); font-size: 14px;">第三条、服务终止</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、已启动过服务的，则针对该订单所签的协议终止。<br/>2、租赁期满或承租方提前退租车辆，经检测完好并结算费用后，该协议终止。<br/>3、车辆、电池丢失报案及理赔结束后，则针对该订单所签的协议自然终止。</p><p><br/></p><h4 style="color: rgba(0, 0, 0, 0.85); font-size: 14px;">第四条、车辆、电池丢失报案及理赔流程</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、报案及理赔流程<br/>1.1车辆、电池发生丢失后，承租人必须第一时间向公安机关报案，并立即联系出租方和出租方网点报备。报案、报备工作必须在车辆、电池丢失的12小时内完成。<br/>1.2承租方需在第一时间向出租方提供车牌号、电池组编码、承租方姓名和身份证复印件、丢失时间、地点等详情。<br/>1.3承租方须提供公安机关要求的佐证资料。公安机关受理后开具有效的丢失证明交于出租方进行受理。<br/>1.4承租方必须协助出租方办理理赔流程并按照出租方要求及时提供理赔资料。<br/>2、所需资料<br/>承租方需提供车牌号、电池组编码、承租方姓名和身份证复印件、发票或收据、丢失时间、地点等详情、公安机关出具的报案回执、公安机关出具的失窃证明（案件正 在侦破中说明/证明）。公安机关出具的证明以公安机关出具的为准。</p><p><br/></p><h4 style="color: rgba(0, 0, 0, 0.85); font-size: 14px;">第五条、争议处理</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">1、因本协议履行过程中引起的或与本协议相关的任何争议，双方应以友好协商解决，若经协商未能解决，双方约定任何一方可向出租方所在地人民法院提起诉讼，因解决争议所产生的一切费用由败诉方承担。<br/>2、本协议为出租方的租赁平台电子协议，承租方交纳服务费后，与租赁订单同时生效。</p>`,
            }}
          ></div>
        )}
        {this.state.id === 't5' && (
          <div id='t5'>
            <h3 style={{ textAlign: 'center' }}>租车步骤</h3>
            <br />
            <br />
            <b>注：本步骤说明金额为测试金额，具体金额以城市显示为准。</b>
            <h4>
              1.当进入飞熊租赁小程序后授权系统定位。（首先确保您手机对支付宝开通定位服务。这样小程序才能识别到您所在区域套餐）
            </h4>
            <br />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms001.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              2.租车时请谨慎选择适合您的租车套餐，点击套餐。下滑页面点击信用租。
            </h4>
            <b>
              注：租赁周期以自然月为单位，最低租赁一月。如您提前退租，将视为您自愿放弃剩余使用权。
            </b>
            <br />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms002.png')}
              alt=''
            />
            <br />
            <h4>
              <br />
              <br />
              3.在弹框页面可以查看您所选购的套餐车型、电池型号、租赁周期等信息，并且您需要在该页面选择您要租赁的站点（系统默认站点为离您现在距离最近的一个）。
              <br />
            </h4>
            <b>注：如果您发现此套餐不是您要选择的套餐，请返回到首页重新选择。</b>
            <br />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms003.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              4.在确认完套餐信息及提车点后，点击确认进行支付宝预授权审核。
              <br />
              在您审核通过时，会显示如左图，将为你减免冻结资金。如果审核没有通过会显示如右图，将会跳转到冻结页面，进行资金冻结，如下图。
            </h4>
            <b>
              注：冻结资金以及解冻资金记录可以在支付宝账单查看，冻结资金会于您结束该订单时立马解冻。冻结资金可以对支付宝余额、余额宝、花呗额度、银行卡等账户冻结，资金将冻结在您支付宝账户内，租车期间无法使用。
            </b>
            <br />
            <img
              style={{ width: '49%' }}
              src={require('@/statics/img/rerms/terms004.png')}
              alt=''
            />
            <img
              style={{ width: '49%' }}
              src={require('@/statics/img/rerms/terms005.png')}
              alt=''
            />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms006.png')}
              alt=''
            />
            <br />
            <h4>
              <br />
              <br />
              5.进行订单支付时，请自行阅读免责申明，并注意您套餐的起止日期。
            </h4>
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms007.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              6.在待提车页面，如果忘记购买保险，7天内可在保险信息栏选择“购买保险”。
              在页面下部，您可以电话咨询提车点工作人员并且通过地图找到提车点位置。
              如果您放弃提车，请点击申请退款按钮，进行退款。（申请退款将扣除套餐金额10%的手续费。）
            </h4>
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms008.png')}
              alt=''
            />
            <img
              style={{ width: '100%' }}
              src={require('@/statics/img/rerms/terms009.png')}
              alt=''
            />
            <h4>
              <br />
              <br />
              7.如果您已经退出到首页，想要查询订单详情或购买保险。可以依序找到我的-我的订单，然后点击您进行中的订单查看详细信息及购买保险。
            </h4>
            <b>
              注：飞熊租赁套餐以月为单位进行租赁，到期需手动续租，不存在自动续租业务。如果您下错提车点请联系400-081-1818售后电话，按1并转到所在城市客服。
            </b>
          </div>
        )}
        {this.state.id === 't6' && (
          <div
            id='t6'
            dangerouslySetInnerHTML={{
              __html: `<h3 style="text-align: center;">退租说明</h3><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">1.如何退租？</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">用户在退租时，需在我的——我的订单，找到需要退租的订单，点击订单详情向下滑动，点击退租按钮并确认。<br/>在您点击完退租按钮后，需在当天将您退租订单对应的车辆、电池送还至提车点。在提车点工作人员检查车辆、电池完好后，请您确认工作人员点击同意收车按钮，并查看您的订单是否为已完成状态。<br/>如您当天未及时送还至提车点，订单将变为租车中状态，由此产生的违约金需由您来承担。<br/>注意：车辆、电池发生破损，钥匙、充电器丢失等需要您照价赔偿。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">2.提前退租如何收费？</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">租赁周期：按自然月计算。<br/>如果您提前退租，已收取的租金不予退还（不满一月按一月计算），工作人员检查租赁车辆、电池如发现车辆、电池有损坏或故障，您需要承担相应的维修或更换费用。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">3.待提车状态申请退单？</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">在您下完租赁订单后，如您需要退单，平台将收取套餐租金10%的手续费用。<br/>如您下错提车点，请联系工作人员变更提车点。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">4.超时状态怎么退租？</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">如果您订单处于超时状态，首先需要您支付相应的违约金（30元/天），违约金支付过后订单将变成租车中，这时请您及时点击退租或续租按钮。（退租请参照上述第1点）</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">5.误点退租怎么操作？</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">当您不想退租却误点了退租按钮，如果你订单到期时间大于2天，订单将于当天凌晨变为租车状态；如果您订单距离到期时间小于2天，请及时联系工作人员更改。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">6.退租时冻结资金何时返还？</h4><p style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">如果您租车时有冻结资金，在您完成退租时，冻结资金将立刻返还到原账户。<br/>返还的冻结资金您可以在支付宝账单记录中查看，“预授权解冻**元”的账单即为解冻资金。（在预授权解冻前，请确认所有订单为已完成或已关闭状态）</p><p><br/></p>`,
            }}
          ></div>
        )}
        {this.state.id === 't7' && (
          <div
            id='t7'
            dangerouslySetInnerHTML={{
              __html: `<h3 style="text-align: center;">飞熊租赁隐私保护指引</h3><p><br/></p><p style="color: rgba(0, 0, 0, 0.65);  font-size: 14px;">更新日期：【2020】年【10】月【17】日<br/>生效日期：【2020】年【10】月【17】日</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">1、我们收集的信息</h4><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">本产品是由杭州蚁租网络科技有限公司（以下简称“我们”）研发和运营的外送车辆租赁服务平台，在您使用此类产品的服务的过程中，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的账户安全：<br/>当您使用飞熊租赁产品服务时，我们会手机您的存储信息，用于您使用应用过程中产生的用户信息和订单缓存信息的暂时保存。您可以选择关闭存储信息的授权，但关闭后将无法正常使用该服务。<br/>当您使用免费wifi或则4g功能时，我们会在征得您的同意后，收集您的地理位置信息，用以匹配您所在区域的站点信息，地理位置信息属于敏感信息，拒绝该服务将导致您无法获得附近站点的推送。<br/>当您使用扫描二维码功能时，我们会在征得您的同意后，获取您的相机信息，相机信息属于敏感信息，拒绝提供该信息只会导致您无法使用我们提供的扫描二维码功能，不影响您正常使用其他服务。<br/>另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：<br/>与国家安全、国防安全等国家利益相关的，与公共安全、公共卫生、公共知情等重大公共利益直接相关的。<br/>与犯罪侦查、起诉、审判和判决执行等直接相关的；<br/>出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的。<br/>所收集的个人信息时您自行向设备公众公开的。<br/>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br/>根据您要求签订和履行合同所必需的。<br/>用于维护所提供的产品或服务的安全稳定运行所必需的。<br/>为开展合法的新闻报道所必需的。<br/>出于公共利益开展统计或学术研究所必要的，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br/>法律法规规定的其他情形。<br/>请您理解，我们向您提供的功能和服务时不断更新和发展的，如果某一功能或服务未在前述说明中收集了您的信息，我们会通过页面提示、交互流程、网站公告等形式另行告知，以征求您的同意。<br/></p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">2、信息存储</h4><h5 style="margin: 0px; color: rgba(0, 0, 0, 0.85);">2.1信息存储的方式和期限</h5><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">我们会通过安全的方式存储您的信息，包括本地存储（例如利用app进行数据缓存）、数据库和服务器日志。<br/>一般情况下，我们只会在为实现服务目的所必须的时间内或法律法规规定的条件下存储您的个人信息。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">3、信息安全</h4><h5 style="margin: 0px; color: rgba(0, 0, 0, 0.85);">3.1安全保护措施</h5><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">我们努力为用户的信息安全提供保障，以防止信息的泄漏、丢失、不当使用、未经授权访问和披露等。我们使用多防伪的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。 我们建立了保障个人信息安全专门的管理制度、流程和组织。 我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。</p><h5 style="margin: 0px; color: rgba(0, 0, 0, 0.85);">3.2 安全时间处置措施</h5><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">若发生个人信息泄漏、损毁、丢失等安全事件，我们会启动应急预案，组织安全事件扩大。安全事件发生后，我们会及时以推送通知、邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">4、我们如何使用信息</h4><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">我们严格遵守法律法规的规定以及与用户的约定，按照本隐私保护指引所述使用收集的信息，以向您提供更为优质的服务。</p><h5 style="margin: 0px; color: rgba(0, 0, 0, 0.85);">4.1 信息使用规则</h5><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">我们会按照如下规则使用收集的信息：<br/>我们会根据我们收集的信息向您提供各项功能与服务，包括套餐查询、下单、退租、续租等。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">5、变更</h4><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">我们可能会适时对本隐私保护指引进行修订。当隐私保护指引的条款发生变化时，我们会在版本更新时提醒，并向您说明生效日期，请您仔细阅读，您继续使用飞熊租赁表示您同意我们按照最新的隐私保护指引处理您的个人信息。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">6、其他</h4><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">飞熊租赁《隐私政策》是我们同意适用的一般性隐私条款，其中所规定的用户权利以及信息安全保障适用于飞熊租赁用户。</p><p><br/></p><h4 style="margin: 0px; color: rgba(0, 0, 0, 0.85); font-size: 14px;">7、联系我们</h4><p style="text-indent: 2em; color: rgba(0, 0, 0, 0.65);  font-size: 14px;">当您有其他投诉、建议以及相关其他问题或需要删除所有访问记录时，请与客服热线进行联系。</p>`,
            }}
          ></div>
        )}
        {this.state.id === 't8' && (
          <div
            id='t8'
            dangerouslySetInnerHTML={{
              __html: `<h3 style="text-align: center;">免责条款</h3><p><br/></p><h5 style="margin: 0px; color: rgba(0, 0, 0, 0.85);">平台权利和义务</h5><p><br/></p><p style="color: rgba(0, 0, 0, 0.65);  font-size: 14px;">平台提供车辆保养、维修网点服务。保证合理使用中出现的厂家三包范围内故障维修、具体维修费用及权益和购买新车的售后权益一致。日常使用中因损耗产生的更换小零件、易耗品（如更换刹车片）等由平台负责。<br/>1、车辆外观及人为因素损坏的配件等，由用户自行承担责任，平台可提供更换维修服务，但更换过程中所产生的零件等费用，有用户自行承担。<br/>2、平台不承担由用户使用租赁车辆引发的连带责任和用户使用过程中人员交通意外损害赔偿责任及本合同规定的风险赔付范围之外的任何经济责任。</p><p><br/></p><h5 style="margin: 0px; color: rgba(0, 0, 0, 0.85);">用户权利和义务</h5><p><br/></p><p style="color: rgba(0, 0, 0, 0.65);  font-size: 14px;">1、认真的检查并掌握租赁车辆的各种性能和操作方法，点清随车配置的附件，验收签字后驶离。凡因用户操作不当、保管不善造成的车辆遗失换造成附件损坏，用户应向平台赔偿。<br/>2、租赁期间，发生的电动车驾驶人员伤亡事故、交通事故等与平台无关，所造成的全部经济损失由用户承担。<br/>3、用户租赁期间，发生车辆丢失，用户应承担丢失车辆的赔偿责任。电池如发生丢失，用户应赔偿平台的损失，每组电池按4000元赔偿。<br/>4、用户租赁期间通过飞熊租赁小程序购买保险服务，如发生车辆丢失，用户不承担丢失车架的赔偿责任。如电池丢失，电池按1000元每组赔偿，需用户提供报案证明。<br/>5、用户禁止打开电池盒，如发现私自打开电池盒更换电池行为，每组电池按600元进行罚款。<br/>6、使用租赁车辆应遵守相关法律、法规，因违法、违纪、违章所造成的法律责任，自行负责，并承担驾驶过程中因自身驾驶责任造成的车辆损失。<br/>7、用户必须按照约定的时间、地点归还车辆，还车时必须保证车辆性能良好、车辆整洁、设备齐全，并无任何刮碰现象。<br/>8、用户不得私配甲方出租车辆的钥匙。若造成车辆丢失、损坏等情况必须立即通知平台，并负责赔偿修配所租车辆门锁和点火开关的费用。</p><p><br/></p>`,
            }}
          ></div>
        )}
        {this.state.id === 'ICBC' && (
          <div
            id='ICBC'
            dangerouslySetInnerHTML={{
              __html: `<h2 style="box-sizing: border-box; margin: 0px; padding: 0px 0px 9px; color: rgba(0, 0, 0, 0.85); font-weight: 500; white-space: normal; text-align: center; font-family: 宋体; font-size: 24px; border-bottom: 1px dashed rgb(230, 230, 230); background: rgb(255, 255, 255);"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">中国工商银行快捷支付业务服务协议</span></h2><p><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; font-family: Calibri; background: rgb(255, 255, 255);"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。如有疑义请及时通过工商银行网站或拨打客户服务热线（</span>95588）咨询。如您不同意本协议的任何内容，或者不能准确理解本协议的任何条款，请不要进行后续操作。&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">为明确双方的权利和义务，规范双方业务行为，甲方（个人客户）、乙方（中国工商银行）本着平等互利的原则，就快捷支付业务相关事宜达成本协议。甲方通过互联网（</span>Internet）点击确认或以其他方式选择接受本协议，即表示甲</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">同意接受本协议的全部约定内容，确认承担由此产生的一切责任。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第一条</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">业务定义</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">下列用语在本协议中的含义为：</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">“快捷支付”是指乙方与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">杭州蚁租网络技术有限公司</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">公司（下称</span>‘</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付机构</span>’）向甲方提供的，将甲方银行卡与支付账户签约绑定后，乙方即可根据</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付机构发送的指令，扣划甲方银行卡账户资金的支付服务业务。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&quot;快捷支付&quot;的签约和使用渠道包括但不限于：计算机、手机、电话、掌上电脑、电视、自助终端等设备，具体以乙方及</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付机构提供的快捷支付业务为准。</span>&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; font-family: Calibri; background: rgb(255, 255, 255);"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&quot;手机号码&quot;指甲方在乙方开立银行账户时预留信息中的手机号码</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">或者甲方在乙方认可的第三方机构（例如电信运营商等）办理的本人手机号码。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第二条</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">权利和义务</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">一、甲方应确保用于</span>&quot;快捷支付&quot;签约的银行卡为本人所有，保证在签约过程中提供的信息真实、准确、有效，确保支付行为合法并未侵犯任何第三方合法权益，否则因此造成乙方及其持卡人损失的，由甲方负责赔偿并承担全部法律责任。&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">二、甲方同意将签约过程中所填写的包括但不限于姓名、银行卡号、手机号码、身份证件号码、信用卡有效期等要素用于身份验证，并同意将指定银行卡号与甲方在</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">支付机构开立的指定会员账号建立签约关系。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;乙方收到</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">支付机构发送的上述信息后，将上述信息与甲方在乙方预留的客户信息进行比对验证，验证通过后，乙方为甲方签约银行卡开通快捷支付业务。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">甲方同意乙方将上述信息发送至乙方认可的第三方机构（例如电信运营商等）进行信息查询与核验。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方承诺对甲方签约信息保密，但法律法规和规章另有规定或监管部门等有权机关另有要求的除外。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">甲方同意乙方可根据业务需要变更验证流程、要素和验证标准。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">三、</span>&quot;快捷支付&quot;签约成功后，即视为甲方授权乙方按照非银行支付机构的交易指令从签约银行卡上主动扣划资金。届时甲方不应以未在交易单据中签名、签名不符、非本人意愿交易、未验证银行卡支付密码、未验证银行卡支付盾等原因要求乙方退款或承担其他责任。&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">四、甲方应妥善保管银行卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等相关信息，如遗失银行卡或泄露上述相关信息，甲方应及时通知乙方并办理挂失或销户等相关手续，减少可能发生的损失。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">挂失或销户前的损失，以及因甲方泄露银行卡密码、支付机构账号密码、支付机构支付密码和手机动态密码、数字证书、</span>U-KEY、丢失银行卡等所致损失，由甲方自行承担。&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">五、甲方可通过乙方网上银行等渠道自助查询</span>&quot;快捷支付&quot;业务签约情况并对卡账户支付限额进行管理。任何情况下，甲方设置的支付限额不应超过乙方及</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付机构设置的最大支付限额，如实际支付金额大于支付限额，乙方有权拒绝执行交易指令。乙方保留根据交易安全需要设置或修改最大支付限额的权利。信用卡支付限额同时受限于卡信用额度。</span>&nbsp;Ⅱ类、Ⅲ类账户受账户自身限额限制。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">六、甲方不得利用快捷支付业务进行套现、虚假交易、洗钱等违法行为，有义务配合乙方进行相关调查。如若甲方拒绝配合进行相关调查或乙方认为存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取以下一种、多种或全部措施：（</span>1）暂停或终止提供本协议项下快捷支付服务；（2）终止本协议；（3）取消甲方的用卡资格。若因甲方的前述行为而给乙方造成损失的，甲方应负责赔偿并承担全部法律责任。&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第三条</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">法律适用条款</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">本协议的成立、生效、履行和解释，均适用中华人民共和国法律（除香港、澳门、台湾地区法律）；法律无明文规定的，可适用通行的金融惯例。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">本协议是乙方的其他既有协议和约定的补充而非替代文件，如本协议与其他既有协议和约定有冲突，应以本协议为准。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第四条</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">差错和争议的解决</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">乙方仅为甲方提供安全可靠的支付结算服务，依据</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">支付机构提供的交易指令实施资金扣划。对于因购买商品或服务而产生的一切关于商品、服务及费用扣收的争议均由甲方与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付机构自行协商解决，与乙方无关。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">双方在履行本协议的过程中，如发生争议，应尽量协商解决。协商不成的，任何一方均应向</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">甲方绑定银行卡的开户行所在地有管辖权的人民法院</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">提起诉讼</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第五条</span>&nbsp;协议的终止</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">甲方可通过</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">非银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付机构网站或乙方网上银行、手机银行主动发起解除签约关系的申请。</span>&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&quot;快捷支付&quot;签约关系一旦解除，本协议即告终止。协议终止前已发送乙方处理的交易指令仍有效，甲方应承担相应后果。&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">如因签约卡</span>/折注销、补（换）卡/折等任何原因导致卡/折号变更，须重新签订&quot;快捷支付&quot;签约关系。&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第六条</span>&nbsp;协议的效力</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">本协议与本行借记卡或贷记卡章程或协议相冲突部分，以本协议为准。</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><br/></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">甲方同意，乙方有权变更、暂停本协议项下快捷支付业务服务，有权修改、终止本协议，并于执行前通过乙方网站或其他任何形式进行公告。修改本协议的公告到期后甲方继续办理快捷支付业务的，视同接受有关本协议、快捷支付业务服务的修改内容。甲方不同意的，可以终止本协议。</span>&nbsp;</span></span></p>`,
            }}
          ></div>
        )}
        {this.state.id === 'ABC' && (
          <div
            id='ABC'
            dangerouslySetInnerHTML={{
              __html: `<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px; text-align: center;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span><span style="text-align: center; box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">快捷支付</span></span><span style="text-align: center; box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">授权</span></span><span style="text-align: center; box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">扣款</span></span><span style="text-align: center; box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">三方协议</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: center; font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 27px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">尊敬的客户：为了维护您的权益，请在签署本协议前，仔细阅读本协议各条款（特别是含有黑体字标题或黑体字文字的条款），</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">注意本协议涉及数量和质量、价格或者费用、履行期限和方式、安全注意事项和风险警示、售后服务、民事责任</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">、</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">管辖</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">等内容的条款。请关注个人信息保护的相关法律法规，了解自己的权利义务，合理审慎提供个人信息，维护自身合法权益。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">如您有疑问或不明之处，请咨询您的律师和有关专业人士。如需进行业务咨询和投诉，请拨打农业银行客服热线：</span>95599。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">《</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">快捷支付授权</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">扣款</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">三方协议》已经由中国农业银行股份有限公司（即为</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">）</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">和</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 仿宋_GB2312;">&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 仿宋_GB2312;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; font-family: &quot;Times New Roman&quot;;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">宝付网络科技（上海）有限公司</span></span>&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">（即为</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">）共同签署，您（即为丙方）勾选“我已阅读并同意《</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">快捷支付授权</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">扣款</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">三方协议》”并点击</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">“</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">确</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">定”</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">，即表示您已全部知晓并充分理解</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">本</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">协议内容和含义，愿意遵守本协议，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">三方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; text-indent: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">意思表示一致，本协议生效。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">&nbsp;</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第一条</span>&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">快捷支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">授权扣款</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">说明</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方为</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在乙方注册、并在乙方或甲方客户端或网页界面申请开通快捷支付的客户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方为</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">开立</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">账户的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">客户，丙方需</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">指定其在甲方已预留手机号码的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">账户作为扣款账户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">3</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方按照</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">提供的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">开通快捷支付的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">操作流程</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">将其在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的注册账户和在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的扣款账户进行绑定。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">4</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方向甲方、乙方做出如下授权：丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">在乙方或其特约商户购买商品或服务时</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">选择快捷支付的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">向乙方提交</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">电子</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">支付指令</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">后</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">授权由乙方向甲方发起电子支付指令，并授权甲方根据乙方发送的指令将丙方扣款账户上的资金划转至乙方在甲方开立的备付金账户。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第二条扣款</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">适用范围及</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">支付限额</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 13px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">三方经协商一致，借记卡快捷支付应用于购买商品或服务的充值业务、消费业务、缴费业务、理财业务及还款等业务，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">不得</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">应用于转账业务、融资业务、保证金业务等。贷记卡快捷支付仅限应用于购买商品或服务的消费业务、缴费业务，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">不得</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">应用于充值业务、转账业务、融资业务、理财业务、还款业务及保证金业务等。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">默认交易限额如下：</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: Arial;">√</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">□借记卡快捷支付：</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">日单笔、日累计限额均为人民币</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">5000元</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: Arial;">√</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">□贷记卡快捷支付：</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">日单笔限额人民币</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">20000元，日累计限额人民币50000元</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲乙双方有权根据有关法律法规和业务经营需要调整默认交易限额，并由乙方在</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">其网站</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">相关页面进行公示。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); font-family: &quot;Times New Roman&quot;; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方有权</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">通过</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方柜面、网</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">上银行</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">、掌上银行等渠道</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">在上述默认交易限额范围内</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">自</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">主</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">修改交易限额，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">修改后</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">交易限额以丙方设置为准。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第三条扣款的交易验证方式</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">单笔金</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">额不超过</span>200<span style="box-sizing: border-box; margin: 0px; padding: 0px;">元的小额支付业务，由乙方代替甲方进行交易验证。单笔金额在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;;">200</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">元以上（不含</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;;">200</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">元）的交易，双方约定采用以下方式进行交易验证：</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">□甲</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">进行交易验证（乙方不属于</span>“<span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;;">A</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">”类支付机构时，只可选此选项）</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">□乙方代替甲方进行交易验证</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方代替甲方进行交易验证的，乙方应在进行交易验证后向甲方发送电子支付指令。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方进行交易验证的方式为：乙方发送电子支付指令时，将</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">身份信息和签约信息（包括但不限于：签约编号或账户所有人编号、账号）传送给甲方，甲方根据上述要素匹配</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">是否为丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">，并通过向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">发送短信验证码</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">等</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">方式，完成交易验证。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">3.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">代替甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">进行交易验证的方式为：</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方将采用静态密码、数字证书、电子签名、一次性密码或采用客户本人生理特征等作为验证要素。乙方应当采用安全有效的验证手段核验</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">身份信息及交易信息，并通过安全的交易渠道与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">及甲方传递数据。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方采用数字证书、电子签名作为验证要素的，数字证书及生成电子签名的过程应符合《中华人民共和国电子签名法》、《金融电子认证规范》（</span>JR/T0118-2015<span style="box-sizing: border-box; margin: 0px; padding: 0px;">）等有关规定，确保数字证书的唯一性、完整性及交易的不可抵赖性。乙方采用一次性密码作为验证要素的，应当防范一次性密码获取端与</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">电子</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">支付指令发起端为相同物理设备而带来的风险，并将一次性密码有效期严格限制在最短的必要时间内。乙方采用客户本人生理特征作为验证要素的，应当符合国家、金融行业标准和相关信息安全管理要求，防止被非法存储、复制或重放。</span>&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">因交易验证方式、验证渠道不安全等原因给甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">或丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">造成损失的，由乙方承担赔偿责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">四</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">条</span>&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的权利和义务</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方按照乙方发送的电子</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">支付</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">指令将丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">扣款账户上的资金扣划</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">至</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">开立的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">备付金</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">账户。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2.甲方尊重和维护丙方作为消费者的合法权益，严格按照消费者权益保护相关法律法规保护丙方合法权益。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">3</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">对以下情</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">形</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">不承担责任：</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>1）乙方发送的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">电子支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">指令信息不完整、不明确、存在乱码等</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">导致甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">无法执行指令的；</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>2）乙方发送错误的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">电子支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">指令，甲方据此指令执行后发生扣款差错的；</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>3）丙方扣款账户的存款余额不足或状态为挂失、冻结、销户等非正常状态导致扣款失败</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">；</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>4）乙方未能按照甲方操作流程正确操作造成损失</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">；</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>5）其他不可抗力或者不可归责于甲方的情</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">形</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">4</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">乙方与</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">之间、乙方与其特约商户之间或乙方特约商户与</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">之间的基础交易产生的纠纷，由乙方与其特约商户处理并承担相应责任，甲方不介入上述纠纷，不承担相关责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">5</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方可根据中国人民银行有关账户管理的规定等外部监管要求，采取中止银行账户所有业务、暂停银行账户非柜面业务、降低限额等措施。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">五</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">条</span>&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的权利和义务</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">应当在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">开立</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">备付金专用存款</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">账户。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方应当采取有效措施，确保</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在执行支付指令前可对收付款客户名称和账号、交易金额等交易信息进行确认，并在支付指令完成后及时将结果通知</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。因交易超时、无响应或者系统故障导致支付指令无法正常处理的，乙方应当及时提示</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">；因</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">原因造成支付指令未执行、未适当执行、延迟执行的，乙方应当主动通知</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">更改或者协助</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">采取补救措施。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">3.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方应确保向甲方发送的交易信息</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">电子</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">支付</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">指令真实、准确、完整、有效</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">因乙方发送的交易信息或</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">电子支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">指令不真实、不准确</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">、</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">不完整、</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">无效</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">导致</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">错误、失败、延迟</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">，由乙方承担责任，给甲方或</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">造成损失的，乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">还应予以赔偿。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">4.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">不得篡改丙方指令，不得假冒丙方指令，也不得增加扣款金额；</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">如实施上述行为，致使</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">提供扣款等支付结算服务被丙方提出权利主张的，由</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">负责处理并承担全部责任，由此给丙方、</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">造成的损失由</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">负责赔偿。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">5.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">负责向丙方提供商品或者服务、业务查询、咨询、投诉、打印及发送发票等电子商务服务。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">6</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">应当保证交易数据的安全性、保密性、完整性，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">并</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">应当</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">确保交易信息</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">的</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">真实性、完整性、可追溯性以及在支付全流程中的一致性，不得篡改或者隐匿交易信息。乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">负责处理因安全认证不足而产生的差错交易及风险交易，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">并</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">承担相关责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">7.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方不得存储</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">银行卡</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">磁道信息或芯片信息、验证码、密码等敏感信息，原则上不得存储银行卡有效期。因特殊业务需要，确需存储</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">银行卡有效期的，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">应在取得丙方的授权、并经甲方同意后，以加密形式存储。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方应当以</span>“最小化”原则采集、使用、存储和传输</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">信息，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">且应事先</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">告知</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">相关信息的使用目的和范围</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">并取得丙方同意</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。乙方不得向其他机构或个人提供</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">信息，法律法规另有规定，以及经</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">本人逐项确认并授权的除外。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">8.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">应</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">通过协议约定禁止其特约商户存储</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">银行卡的磁道信息或芯片信息、验证码、有效期、密码等</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">敏感信息，并采取定期检查、技术监测等必要监督措施。特约商户违反协议约定存储上述敏感信息的，乙方应当立即暂停或者终止为其提供网络支付服务，采取有效措施删除敏感信息、防止信息泄露，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">并依法承担因相关信息泄露造成的损失和责任，给账户所有人或甲方造成损失的，乙方还应</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">予以</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">赔偿。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">9.如甲乙双方合作开展贷记卡快捷分期业务的，乙方应在其合作商户的网站上，明确告知丙方需承担的各期手续费费率。合作期间，甲方有权调整向丙方收取的贷记卡快捷分期手续费，并将提前___个工作日，以函件形式通知乙方。乙方应在收到甲方函件后，及时通知其合作商户在网站上调整丙方分期手续费费率。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">10.乙方应当向丙方充分提示网络支付业务的潜在风险，及时揭示不法分子新型作案手段，对丙方进行必要的安全教育，并对高风险业务在操作前、操作中进行风险警示。乙方为丙方购买合作机构的金融类产品提供网络支付服务的，应当确保合作机构为取得相应经营资质并依法开展业务的机构，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">对相关金融类产品的合法合规性进行尽职调查，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">并在首次购买时向丙方展示合作机构信息和产品信息，充分提示相关责任、权利、义务及潜在风险，协助丙方与合作机构完成协议签订。</span>&nbsp;&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">六</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">条</span>&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">丙方的权利和义务</span></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方应当按照</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">或</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在客户端或网页界面上</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">提供的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">流程提示</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">，正确指定</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在乙方的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">注册账户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">和在甲方的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">扣款账户，并将</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">注册</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">账户和扣款账户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">进行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">绑定。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">2</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">执行</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">电子支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">指令后，丙方不能要求变更或者撤销</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">电子支付</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">指令。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">3</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方应当妥善保管本人在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的注册账户信息及相关密码，不得向他人透露，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">因丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">对</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">注册</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">账户信息和密码</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">保管不善</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">造成的资金损失，甲乙双方不承担责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">4</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方应妥善保管本人在</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">的银行</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">账户</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">关键信息（密码、有效期、</span>CV</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">V</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">2码、绑定的手机号等）、网上银行</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">数字</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">证书及其密码、身份证件信息，不得泄露上述信息。因丙方保管不善造成的损失，甲乙双方不承担责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">5</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方知悉并同意，对于</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">乙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">交易网站和</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">网上支付系统而言，使用丙方拥有的相关账户、证书和密码</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">并通过验证后</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">即视为丙方行为，行为后果由丙方承担。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">6.丙方知悉并同意，办理贷记卡分期业务需同时遵守农业银行《</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">商户日付款业务条款及细则</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">》。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">7</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">甲乙双方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">可基于执行国家法律法规、政策、外部监管规定、维护客户权益、保障交易安全、进行系统升级、提升服务质量等原因变更本协议、暂停或终止支付结算业务服务，并通过</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">双方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">门户网站</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">进行</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">公示。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">丙方</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">不同意的，可以在履行本协议项下应尽义务后终止服务、解除本协议；各方协商一致的，也可变更相关服务和对应协议内容。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">本协议中</span>“法律法规”包括法律、行政法规、地方性法规、规章、司法解释及其他具有法律效力的规定</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">七</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">条</span>&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">异常账务处理</span></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方发现扣款金额与其交易金额不符</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">或者</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">交易非本人授权或参</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">等其他风险事件的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">，应当及时向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">进行查询或者投诉</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">并可向公安机关报案。乙方受理投诉后，将</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">核对扣款信息。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">因</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">安全认证不足或其他等原因造成丙方账户扣款差错的，由</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">负责补偿丙方资金损失。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第八条</span>&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">客户信息保护</span></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 黑体;">1.丙方授权中国农业银行可基于业务办理、履行合同及开展风险管理的需要，自本授权签署之日起，收集、传输、加工、保存、查询和使用丙方信息（包括身份信息、财产信息、账户信息、信用信息、交易信息、衍生信息及在与丙方建立业务关系过程中获取、保存的其他信息）。各方业务关系终止后，中国农业银行将严格依照法律法规的规定和与丙方的约定，保存和处理丙方信息。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2.中国农业银行承诺将严格遵守法律法规规定，在收集、使用丙方信息时，遵循合法、正当、必要的原则，并在丙方授权的范围、内容和期限内收集、传输、加工、保存、查询和使用丙方信息。不泄露、篡改、毁损丙方信息，不出售或者非法向他人提供丙方信息，不收集、查询、使用与所提供服务或办理业务无关的丙方信息，不违反法律法规的规定和各方的约定收集、查询、使用丙方信息。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">3.中国农业银行将依法承担客户信息安全保护的法律责任。违反法律法规的规定及与丙方的约定，超出丙方授权范围收集、传输、加工、保存、查询和使用丙方信息的法律责任由中国农业银行承担。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">第</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">九</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">条</span>&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">协议终止</span></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">1</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方有权</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">通过</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">在线</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">解除或到甲方营业网点</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">解除本协议。丙方解除本协议的，本协议终止，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">丙方不再授权</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲乙双方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">根据本协议进行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">扣款</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgba(0, 0, 0, 0.65); font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); text-align: justify; font-family: &quot;Times New Roman&quot;; text-indent: 28px; line-height: 23px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">2</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">和乙方解除双方之间签订的快捷支付业务合作协议</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">的，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲乙双方业务合作终止，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">本协议自动终止，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">和乙方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">将不再为丙方办理</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">快捷支付</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">授权扣款。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">乙方应在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">其</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">网站上公告</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">上述事宜</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体;">。</span></p><p><br/></p>`,
            }}
          ></div>
        )}
        {this.state.id === 'BOC' && (
          <div
            id='BOC'
            dangerouslySetInnerHTML={{
              __html: `<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: center; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">中国银行股份有限公司借记卡快捷支付服务协议（总行版）</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: center; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">请客户认真阅读本协议文本，如有疑义，请及时拨打中国银行股份有限公司客户服务热线</span>95566咨询。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">1.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">中国银行股份有限公司借记卡快捷支付业务（以下简称</span>“快捷支付业务”）是中国银行股份有限公司（以下简称“中国银行”）和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">杭州蚁租网络科技有限公司</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">公司联合为中国银行借记卡持卡客户（以下简称</span>“客户”）通过</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder; font-family: &quot;Times New Roman&quot;; font-size: 14px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span>&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">账户购买商品支付货款的一项电子银行服务业务，凡是持有中国银行股份有限公司在中国大陆地区发行的借记卡且同时为</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">杭州蚁租网络科技有限公司</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">用户的客户，均可申请该业务。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-weight: bold; font-size: 16px;">2.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">客户通过互联网（</span>Internet）在</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">网站或客户端，选择在线与中国银行签订本服务协议，将指定的借记卡与此时登录的账户进行关联，开通快捷支付功能，并承担由此产生的一切责任</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">3.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户同意，中国银行以</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">传送至中国银行的户名、卡号、手机号码等身份要素作为确认客户身份、为客户开通快捷支付业务的唯一证据。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; color: rgb(255, 0, 0); font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">中国银行比对户名、卡号、手机号码与客户在银行预留信息一致后，通过</span>95566发送手机动态密码至客户预留手机号上，并对</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">传送的客户填写的手机动态密码进行验证，验证一致通过后，完成客户指定的借记卡与此时所登录账户的关联&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; color: rgb(255, 0, 0); font-size: 16px;">。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户须保证在中国银行预留手机号码为本人手机号码并确保其准确性。</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">基于提高交易安全的目的，中国银行有权变更上述身份要素。客户须妥善保管本人中国银行借记卡信息，本人身份信息、手机动态密码、安全认证工具等敏感信息，不得将敏感信息向他人透露。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">因客户银行预留信息错误，或个人信息、手机等保管不善产生的风险及损失由客户本人承担。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">4.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">开通快捷支付业务后，客户同意并授权中国银行在本协议约定的服务范围内，将其所关联借记卡的原有支付验证方式变更为按照</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">公司发送的交易指令从客户指定的借记卡账户中支付相应款项。客户需在其绑定的借记卡的余额内进行支付，否则中国银行有权拒绝执行交易指令</span>”。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-weight: bold; font-size: 16px;">5.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户同意并授权中国银行开通免费的账户变动即时通知服务。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">6.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">中国银行可根据业务发展需要，设置或修改支付限额，客户对此无异议，客户办理快捷支付业务时需同时受中国银行和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">设置的支付限额的约束。在任何情况下，支付金额不应超过中国银行或</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">设置的支付限额（以较低者为准）。如实际支付金额大于规定的支付限额，中国银行将拒绝执行交易指令。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">7.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">本协议项下，中国银行仅提供通过</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">发生的支付结算服务。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户因通过</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">商户购买商品而产生的一切关于商品或服务质量、商品交付，交易款项扣收与划付的争议均由客户与商户或商品</span>/服务的实际销售商自行协商解决</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">8.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">客户不得利用中国银行快捷支付业务进行虚假交易、洗钱、诈骗、恐怖融资等行为，且有义务配合中国银行进行相关调查，一旦客户拒绝配合进行相关调查或中国银行认为客户存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，中国银行有权采取以下一种、多种或全部措施：（</span>1）暂停或终止提供本协议项下快捷支付业务服务；（2）终止本协议；（3）取消客户的用卡资格。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">9.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户同意中国银行就快捷支付业务的开展，向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">提供客户留存在中国银行的户名、银行卡号、证件类型、证件号码、手机号码等信息。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">10.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户可以登录中国银行官方网站撤销本人名下指定借记卡与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">账户关联的快捷支付功能&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; line-height: 24px; font-size: 16px; font-family: 楷体_GB2312;">。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">11.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">中国银行系统升级、业务变化、收费变更，或根据业务发展需要修改本协议，中国银行将提前进行公告。若客户有异议，有权选择撤销相关服务，若客户选择继续接受该服务的，视为客户同意并接受相关业务或协议按变更或修改后的内容执行。双方同意，本协议所称公告均指在中国银行网点、中国银行网站【</span>&lt;http:</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">12.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">客户应按中国银行公布的收费要求按时足额支付快捷支付业务服务费及其他各类相关费用，中国银行公告变更收费要求的，客户在公告执行后继续办理快捷支付业务的，视同接受变更内容。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-weight: bold; font-size: 16px;">13.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">选择打勾的客户，视同已通读上述条款，对条款的内容及其后果已充分理解，对所有内容均无异议。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; margin-left: 24px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; font-size: 16px;">14.&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">本协议在客户在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">飞熊租赁</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;">&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 楷体_GB2312; line-height: 24px; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">网站页面点击</span>“确认开通并付款”后生效。本协议的生效、履行及解释均使用中华人民共和国法律（为本协议之目的，不含中国香港、澳门、台湾地区法律）。</span></p>`,
            }}
          ></div>
        )}
        {this.state.id === 'CCB' && (
          <div
            id='CCB'
            dangerouslySetInnerHTML={{
              __html: `<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: center; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 32px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹小标宋; font-size: 27px;">中国建设银行总对总快捷客户授权协议</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: center; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 32px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">中国建设银行总对总快捷客户授权协议（以下简称</span>&quot;本协议&quot;）是中国建设银行股份有限公司（以下简称“甲方”）与个人客户（以下简称“乙方”）就中国建设银行总对总快捷电子支付服务的相关事宜达成的协议。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第一条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">总对总快捷业务是指持有甲方活期储蓄账户或信用卡账户的乙方，通过网银盾或短信验证码等认证方式，验证账号、户名、证件号、手机号等身份信息后，授权指定商户在一定限额内就该银行账户向甲方发出扣款指令，并授权甲方根据商户指令从该银行账户内扣款的支付方式。乙方在指定商户办理支付业务时不需再跳转到甲方支付页面，直接通过商户系统向甲方发起交易申请，完成支付（含分期）。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px; background: rgb(255, 255, 0);"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">甲乙双方同意，上述授权的前提是，由商户收集并向甲方提供的乙方在申请本业务过程中所填写的要素，包括但不限于姓名、身份证件号、银行卡号、手机号码等，通过甲方的校对核验。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第二条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">甲方的权利和义务</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">1.甲方为乙方提供本协议约定的电子支付服务。乙方授权甲方按照</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;杭州蚁租网络科技有限公司&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">向甲方</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">提交的支付扣款指令及支付扣款数据，直接从乙方指定的银行账号中扣缴相关费用至</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">该商户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">指定的银行账户。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">2.乙方经</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">向甲方提交姓名、身份证件号、银行卡号、手机号码等信息，甲方校对核验后建立乙方银行账号与商户网站用户号的绑定支付关系。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">3.甲方不对商户提交的扣款交易指令进行实质性审核，不负责审核商户提交扣款指令的真实性、合法性、准确性。乙方如对甲方依据商户指令进行扣款的行为发生争议，应与其授权商户协商解决，甲方不承担相关责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">4.甲方可根据业务发展需要，设置或修改支付限额。乙方在使用本服务时需同时受甲方和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">设置的支付限额的约束。如实际支付金额大于支付限额，甲方将拒绝执行交易指令。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">5.为保护乙方权益，控制业务风险，甲方有权随时变更乙方开通快捷支付后通过甲方进行电子支付时的身份验证方式，例如甲方可要求乙方在选择快捷支付时应当通过甲方网上银行或账号验证，或者使用网银盾或者短信验证码等方式作为校验标准。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第三条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方的权利和义务</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">1.乙方应先拥有甲方借记卡（折）或贷记卡银行账号，并遵守《中国建设银行股份有限公司电子银行个人客户服务协议》。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">2.乙方向甲方承诺:其已授权</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">向甲方提交支付扣款指令及支付扣款数据；乙方保证</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;&nbsp;</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">向甲方提交的支付扣款指令及支付扣款数据均为乙方真实意愿表示，该指令及数据真实、合法且有效，乙方愿意承担相关法律后果。</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">3.乙方在使用本服务时需同时受甲方和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">设置的支付限额的约束。在任何情况下，支付金额不应超过甲方或</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">设置的支付限额（以较少者为准，以下简称</span>“支付限额”）。如实际支付金额大于支付限额，甲方将拒绝执行交易指令。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">4.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">乙方应妥善保管本人身份证件、银行账号、银行账号密码、网上银行交易密码、网上银行登陆密码、手机动态验证码、网银客户号以及网银盾等安全认证工具，不得将本人银行密码、手机动态验证码等信息向他人透露，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">否则由此导致的乙方损失，甲方不承担赔偿责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">5.</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">乙方应保证业务开通时在甲方预留的手机号（开户以及开通网银、手机银行等电子渠道时预留的手机号码）为本人手机号码，否则由此导致的乙方损失，甲方不承担赔偿责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">6．</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方不得利用总对总快捷业务进行套现、虚假交易、洗钱等行为，且有义务配合甲方进行相关调查，一旦乙方拒绝配合进行相关调查或甲方认为乙方存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，甲方有权采取以下一种、多种或全部措施：（</span>1）暂停或终止提供本协议项下总对总快捷服务；（2）终止本协议；（3）取消乙方的银行卡使用资格。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第四条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">在本协议下</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">甲方仅向乙方提供</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">支付结算服务。乙方因购买或使用</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">的产品或服务而产生的一切关于产品质量、服务质量及费用扣收的争议，均由乙方与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">杭州蚁租网络科技有限公司</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">自行协商解决。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第五条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">甲乙双方在履行本协议的过程中如发生争议，应协商解决；协商不成的，向甲方住所地人民法院提起诉讼。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">本协议适用中华人民共和国法律。为本协议之目的，中华人民共和国法律不包括香港特别行政区、澳门特别行政区及台湾地区法律。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第六条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">特别约定条款如下：</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">1.乙方承诺在指定的银行付款账户中保留足够的余额，并保持账户处于正常状态。因付款账户余额不足、账户被冻结、销户等原因而导致的无法成功支付费用及所造成的一切经济纠纷和违约责任、损失等全部法律后果乙方自担。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">2.乙方支付费用的发票等由&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">杭州蚁租网络科技有限公司</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">提供，甲方无需协助传递。</span>&nbsp;&nbsp;&nbsp;&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">3.乙方承诺如对扣费项目、扣费金额等有异议，将自行与收款方协商处理。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">4.甲方接收到的商户电子扣款指令、信息不明确、不完整、不清晰或无法辨认，导致甲方无法扣款，甲方不承担责任，由乙方与其授权商户协商解决。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">5.如乙方授权商户向甲方传送的姓名、身份证件号、银行卡号、手机号码等等信息有误，导致甲方不能按约定扣划资金或致使乙方及商户发生损失的，甲方不承担责任，由乙方与其授权商户协商解决。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第七条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">不可抗力</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">因不可抗力（包括但不限于甲方不能预见、不能避免并不能克服的战争、暴动、自然灾害、政府行为、社会事件、黑客攻击、供电、通讯、交易系统故障等客观情况）导致乙方损失的，甲方将视情况协助乙方解决或提供必要的帮助。根据不可抗力的影响，甲方部分或全部免除责任。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 47px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第八条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方选择并点击本协议下方</span>“同意”按钮后，视同接收并同意与甲方签订《中国建设银行总对总快捷客户授权协议》。</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 28px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">第九条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">如甲方与</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; text-indent: 47px;">杭州蚁租网络科技有限公司</span>&nbsp;&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">业务合作终止后，自终止之日起本协议自动失效。乙方如需注销总对总快捷业务，乙方可以通过商户端发起注销申请，业务注销自甲方同意并在银行系统中设置成功后生效。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 28px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">第十条</span><span style="box-sizing: border-box; margin: 0px; padding: 0px;">乙方确认：</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">已</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">仔细阅读了本协议，</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">并</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">特别注意了字体加黑的条款，对本协议条款的含义及相应的法律后果已全部知晓并充分理解，愿意</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">遵守</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 彩虹粗仿宋; font-size: 21px;">其全部内容；甲方已应要求对相关条款进行了充分的提示和说明。</span></span></p>`,
            }}
          ></div>
        )}
        {this.state.id === 'CMB' && (
          <div
            id='CMB'
            dangerouslySetInnerHTML={{
              __html: `<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: center; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 32px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; position: absolute; z-index: 1; left: 0px; width: 244px; height: 84px;"><img width="244"height="84"src="https://cdn.uukit.com/vendor/ueditor/me/themes/default/images/spacer.gif"/></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 21px;">&nbsp;&nbsp;&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">招商银行快捷支付业务线上用户</span></span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: center; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 32px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 21px;">服务协议</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">特别提示：</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、招商银行快捷支付业务线上用户服务协议（以下简称“本协议</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">”</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">）是招商银行股份有限公司（以下简称</span>“我行”或</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">“</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">招商</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">银行</span>”</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">）与个人用户（以下简称</span>“您”）就招商银行快捷支付服务的相关事宜达成的协议。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2、招商银行快捷支付服务是招商银行与商户合作推出的支付业务，即凭借您在商户端的注册信息经招商银行验证后，无需招商银行“一卡通”账户密码即可完成的支付交易。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3、您通过点击确认或以其他方式选择接受本协议，即表示您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">知悉并</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">同意接受本协议的全部内容，确认承担由此产生的一切法律后果。在</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">确认接受本协议之前，请您仔细阅读本协议的全部内容</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">如果</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">不</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">同意</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第一条&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">总章</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、您申请开通快捷支付业务时，需将本人的商户注册信息与本人名下的招商银行“一卡通”账户进行绑定，将该绑定的“一卡通”账户作为快捷支付业务项下的付款账户。成功开通本业务后，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">您在指定商户办理支付业务时不需再跳转到我行支付页面，直接通过商户系统向我行发起交易申请，完成支付。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 32px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2、快捷支付业务中，您授权</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">由商户收集并向我行提供您在申请本业务过程中所填写的要素，我</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">行将对您在银行端预留的要素信息进行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">校对核验</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">通过</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">验证</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">后，为您在我行开立的对应</span>“一卡通”开通</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">快捷支付功能。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3、快捷支付业务中，您授权指定商户负责您相关信息的收集、识别、储存和验证处理。您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">授权指定商户在一定限额内就指定</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">“一卡通”账户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">向我行发出支付扣款指令，并授权我行根据该商户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">的交易支付指令直接扣划您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">指定的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">“一卡通”账户资金。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第二条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">我行的权利和义务</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">我行为您提供本协议约定的电子支付服务。您授权我行按照</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; text-align: justify;">杭州蚁租网络科技有限公司</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">向我行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">提交的支付扣款指令及支付扣款数据，直接从您指定的快捷支付银行账号中扣缴相关费用至</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">该商户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">指定的银行账户。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2、在快捷支付业务中，消费交易无需银行卡密码，您向指定商户发出的交易指令和提供的验证信息作为您进行快捷支付签约和交易的凭据。您同意并授权该快捷支付交易的扣款指令经由商户向我行提交并予以直接扣款处理。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3、我行接收到的商户电子扣款指令信息不明确、不完整、不清晰或无法辨认，导致我行无法扣款，我行不承担责任，由您与商户协商解决。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">4、我行有权根据保障客户资金交易安全以及有效控制风险的原则，修改或调整指定商户快捷支付的交易次数与交易金额限制、暂停或终止向特定用户提供快捷支付服务。因此影响您与商户交易的，我行不承担任何责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">5、我行可根据业务发展需要，设置或修改支付限额。您在使用本服务时同时受我行和</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; text-align: justify;">杭州蚁租网络科技有限公司</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">设置的支付限额的约束。如实际支付金额大于支付限额，我行将拒绝执行交易指令。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">6、我行不对商户提交的扣款交易指令进行实质性审核，不负责审核商户提交扣款指令的真实性、合法性、准确性。您如对我行依据商户指令进行扣款的行为发生争议，应与商户协商解决，我行不承担相关责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第三条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">您的权利和义务</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、开通招商银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">快捷支付业务的前提为您是我行</span>“一卡通”的合法持卡人，并且是能够承担相应法律责任的自然人。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">、</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">我行承诺：您已授权</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; text-align: justify;">杭州蚁租网络科技有限公司</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">收集本人相关信息并提供给我行，授权其向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">我行提交支付扣款指令及支付扣款数据，并保证</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">通过</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; text-align: justify;">杭州蚁租网络科技有限公司</span></span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">我</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">行提交</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">的支付扣款</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">指令</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">及支付扣款数据均为您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">真实</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">意思表示，该指令及数据</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">真实</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">、合法、有效，您愿意承担相</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">应</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">法律后果。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">、</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">快捷支付业务由用户免费开通和使用，您无须就快捷支付业务向我行或合作的商户支付任何费用。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">4</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">、您申请开通快捷支付业务时，必须使用本人在商户的注册信息与本人名下的招商银行</span>“一卡通”账户进行绑定。若出现有银行卡不是您本人进行绑定操作行为的情况，因此造成损失或其他法律后果的，我行将不承担任何责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">5</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">、您申请开通快捷支付业务时需设置快捷支付交易密码。在每次进行快捷支付时，您通过输入支付交易密码和商户端发送的短信验证码，或您与商户约定的其他交易验证方式发布每笔支付指令。为确保您银行账户安全，请勿将该密码设置过于简单（如</span>“111111”、“123456”等）或与您个人信息（如出生日期、预留手机号码、证件号码等）相似度过高。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">6</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">、您应妥善保管本人身份证件、银行账号、银行账号密码、网上银行交易密码、网上银行登陆密码、手机动态验证码、快捷支付交易密码等安全认证工具，不得将以上信息向他人透露，否则由此导致的损失，我行不承担赔偿责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">7</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">、您应保证业务开通时在我行预留的手机号为本人手机号码，否则由此导致的损失，我行不承担赔偿责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">8</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">、您应保证通过快捷支付业务发出的交易及扣款指令真实、合法、有效。您</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">不得利用快捷业务进行套现、虚假交易、洗钱等行为，且有义务配合我行进行相关调查，一旦您拒绝配合进行相关调查或我行认为您存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，我行有权采取以下一种、多种或全部措施：</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>1）暂停或终止提供本协议项下快捷服务；</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>2）终止本协议；</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>3）取消您的银行卡使用资格；</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">（</span>4）其他我行认为有助于风险防范的措施；</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">9、您绑定我行的“一卡通”进行快捷支付操作时必须遵守我行有关章程、开户须知以及相应业务规定。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第四条&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">快捷支付业务注销</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、您如需取消快捷支付功能，可向我行或商户端申请办理注销。您在注销该业务后，原绑定的“一卡通”账户依然有效，除快捷支付功能以外的“一卡通”账户业务操作仍然受招商银行有关章程及业务规定的约束。&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2、在我行渠道注销快捷支付业务后，您可重新绑定该“一卡通”账户进行快捷支付业务。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3、如您绑定的“一卡通”卡遗失，应立即通知我行并按照有关挂失的规定办理挂失，同时请注销快捷支付协议。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">4、您对绑定快捷支付的“一卡通”账户申请销户时，该账户的快捷支付功能也被注销。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第五条&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">争议处理</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、在本协议下我行仅向您提供支付结算服务。您因购买或使用</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px; text-align: justify;">杭州蚁租网络科技有限公司</span>&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">的产品或服务而产生的一切关于产品质量、服务质量及费用扣收的争议，均由您与该商户自行协商解决。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2、涉及会员信息以及交易支付指令真实性、准确性，以及支付环节中遇到的任何问题，由您与商户协调解决。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3、您承诺如对扣款项目、扣款金额等有异议，由您自行与商户协商处理。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">4、</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">如您授权商户向我行传送验证要素有误，导致我行不能按约定扣划资金或致使您及商户发生损失的，我行不承担责任，由您与商户协商解决。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第六条</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;<span style="box-sizing: border-box; margin: 0px; padding: 0px;">不可抗力</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、由于不能预见、不能克服、不能避免等不可抗力或不能控制等客观因素导致通讯或系统中断，以致影响“快捷支付”用户消费的，我行不承担任何法律责任。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;</span></span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: bolder;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">第七条&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">特别约定条款</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">1、招商银行对本协议有权进行必要的修改，修改的条款对办理本项业务的所有“快捷支付”用户均有约束力；如您不同意修改条款，有权注销“快捷支付”功能；如您未及时注销“快捷支付”功能的，视同您认可修改后的条款对您的约束力。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">2、本协议适用中华人民共和国法律。为本</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">协议之目的，中华人民共和国法律不包括</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">香港</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">特别行政区、澳门特别行政区</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">及</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">台湾地区法律。</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">未尽事宜除各方另有约定外，依据招商银行业务规定执行。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">3、因</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">履行本协议</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">而</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">产生的或与本协议有关的</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">任何</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">争议，应协商解决；协商不成的，</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">任何</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">一</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">方可</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">向</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">招商银行</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">住所地</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">人民法院</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">提起诉讼。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">4、如我行与</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; text-decoration-line: underline;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">&nbsp;杭州蚁租网络科技有限公司&nbsp;</span></span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">业务合作终止的，自终止之日起本协议自动失效。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px; text-align: justify; font-family: &quot;Times New Roman&quot;; font-size: 14px; white-space: normal; text-indent: 35px; line-height: 37px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">5、用户</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">确认：</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">您确认</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">已</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">仔细阅读了本协议，对本协议条款的含义及相应的法律后果已全部知晓并充分理解，愿意</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">遵守</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 宋体; font-size: 16px;">其全部内容；我行已应要求对相关条款进行了充分的提示和说明。</span></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0px; padding: 0px;"><br/></p><p><br/></p>`,
            }}
          ></div>
        )}
        {this.state.id === 'leaseContractZY' && (
          <div id='leaseContractZY'>
            <p style={{ fontSize: 'medium', whiteSpace: 'normal' }}>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    color: 'rgb(51, 51, 51)',
                    fontSize: '16px',
                  }}
                >
                  <span style={{ fontFamily: 'SimSun' }}>合同版本号：</span>
                  ZL-2020-
                  <br />
                  合同编码：YM-
                </span>
              </strong>
            </p>
            <h1
              style={{
                marginTop: '23px',
                marginBottom: '22px',
                breakAfter: 'avoid',
                textAlign: 'center',
                lineHeight: '70.4px',
                fontFamily: 'Calibri',
                fontSize: '29px',
                whiteSpace: 'normal',
              }}
            >
              <strong>
                <span style={{ fontFamily: 'SimSun', fontSize: '29px' }}>飞熊租赁用户服务合同</span>
              </strong>
            </h1>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲方（平台方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                  <span style={{ fontFamily: 'SimSun' }}>杭州蚁租网络科技有限公司</span>
                  &nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                社会信用代码：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                  {orderData?.platform.taxNo}
                  &nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方（承租方）：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;{orderData?.userInfo.userName}&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                身份证号：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;{orderData?.userInfo.cardNo}&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;{orderData?.userInfo.mobile}&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;&nbsp;&nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙方（
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                商）：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;{orderData?.franchise.companyName}&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                社会信用代码：
              </span>

              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;{orderData?.franchise.taxNo}&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;{orderData?.franchise.mobile}&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                根据《中华人民共和国合同法》等相关法律法规的规定，为明确本协议各方的权利义务关系，经协商一致，签订本合同。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  特
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  别
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  提醒：在承租方（本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  中称乙方）
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  确认
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  同意本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  之前，承租方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  应
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  已清楚知悉并充分理解本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  产
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  品的所有信息，同意向
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  平台
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  方即
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  杭州蚁租网络科技有限公司
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  （本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  中称甲方）申
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  请
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  提供租赁管理服务
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  。一旦承租方接受本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  ，即
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  视为
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  承租方已
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  阅读
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  所有条款，并
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  对
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  条款的含
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  义
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  及相
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  应
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  的法律后果已全部通
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  晓
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  并充分理解，同意接受本
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  协议约
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  束。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  为了维护承租方的合法权益，特别提醒承租方关注本协议条款，请务必仔细阅读本协议条款。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  各方确认并承诺：租赁过程中填写的名称、联系方式、证件信息等准确无误，通过上述地址寄送的任何文书均视为已收到该文书。对于因本协议争议引起的任何纠纷，各方声明司法机关（包括但不限于人民法院）可以手机短信或电子邮件等现代通讯方式或邮寄方式送达法律文书（包括但不限于诉讼文书）。如有变更，将重新签署地址变更确认书并书面通知。各方承担因按照上述地址投递或变更地址而导致无法收到文书所引起的任何法律责任。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  乙方确认并承诺：使用以乙方本人名义注册的且经过实名认证的个人账户在甲方平台（含甲方相关客户端，下同）所从事的所有行为均视为乙方本人行为，包括但不限于订立本协议、申请租赁服务等，该等行为的法律后果均由乙方本人承担。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                租赁标的：车架
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  {orderData?.orderInfo.bikeModelName}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                ，电池：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  {orderData?.orderInfo.dcModelName}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                （如有品牌编号的，填写品牌编号）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  一、甲方权利与义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  基于互联网，以包含飞熊租赁平台网站、小程序、
                </span>
                APP等在内的各种形态（包括未来技术发展出现的新的服务形态）向乙方提供
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租赁
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                物
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                及
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租赁
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                管理服务工作，包括但不限于发布租赁标的或服务，对租赁标的或服务进行评价管理，对租赁标的进行物联网管控，并妥善处理或协助处理平台上有关的交易纠纷等。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span style={{ fontFamily: 'SimSun', fontSize: '16px' }}>2、</span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲方应提供符合合同约定的租赁物
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  3
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、甲方不承担车辆在
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  租赁期间使用过程中产生的一切安全及车辆损坏、灭失责任。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  4
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、甲方不承担乙方使用租赁
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  车辆引发的连带责任及任何经济责任。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  5
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、甲方不承担乙方使用租赁车辆期间发生
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  交通违章的处罚，甲方有权将承租人作为责任人提交公安交通管理部门处理。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  6
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、甲方对乙方或承租人的信用信息有知情权。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  二、乙方的权利和义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、认真的检查并掌握租赁车辆的各种性能和操作方法，点清随车配置的附件，验收签字后驶离。凡因乙方操作不当、保管不善造成的车架、锂电池遗失或附件损坏，乙方应按照本合同约定（未约定的按照市场价）向甲方赔偿。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、乙方使用租赁车辆过程中发生的交通事故及其他安全事故造成乙方或第三人人身或财产损害的所有责任均由乙方自行承担，与甲方无关。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、乙方租赁期间发生车架、电池、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  letterSpacing: '1px',
                  fontSize: '16px',
                }}
              >
                或配件
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  letterSpacing: '1px',
                  fontSize: '16px',
                }}
              >
                盗抢、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丢失
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                损毁
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                灭失
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>，乙方应承担赔偿责任。车架按</span>
                2000元/辆
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                不含电池
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ；电池如果发生丢失，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                锂电池
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>按</span>
                4000元/组赔偿，锂电池充电器按380元赔偿
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                4、乙方租赁期间可以在飞熊租赁小程序上购买丢车服务，服务费为每年90元，乙方购买该服务后，如租赁期间发生车架丢失，乙方提供报案证明即无需承担丢失车架损失，如租赁期间锂电池丢失的，丢失的锂电池额为3000元/组，即乙方按1000元/组进行赔偿。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                5、乙方禁止打开电池盒，如发现私自打开电池盒更换电池行为，每次每组电池按600元向甲方支付违约金。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                6
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                按照本协议约定及时足额支付租赁费用，合理使用租赁车辆﹙除另有约定外﹚，租赁车辆的合理使用指以满足乙方使用需要的驾驶使用。
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                费用
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                为按月收取，如乙方未到期进行退租，则甲方视为乙方自动放弃剩余使用期限，所付费用不予退还。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                7
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、使用租赁车辆应遵守相关法律、法规、规章、政策等，因违法、违规、违章所引起的刑事、民事、行政责任，均由乙方自行负责。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                8
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、乙方必须按照约定的时间、地点归还车辆，还车时必须保证车辆性能良好、电池满电、车辆整洁、设备齐全，并无任何刮碰现象，否则乙方应按照本协议约定向甲方赔偿。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                9
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、乙方不得私配甲方出租车辆的钥匙。若造成车辆丢失、损坏等情况必须立即通知甲方，并向甲方赔偿车辆损失及修配所租车辆门锁和点火开关等车辆配件的费用。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                10、不得私自组装、改装、拆卸、更换租赁车辆的零部件，亦不得在租赁车辆上增加任何组件或配件骑行，若乙方违反本协议约定而造成任何自身或第三人人身或财产损害的，甲方不承担任何责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                11
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、不得买卖、抵押、质押、转租、转借租赁车辆；不得擅自变动、修理、添改租赁车辆任何部位或部件。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                12
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、保证租赁车辆为合同登记的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                承租人
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                驾驶
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，不得随意变更实际使用人
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。在合同期内，如乙方登记的信息发生变化，应及时通知甲方，否则发生任何事务责任，将由乙方承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  三
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  丙
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  方的权利和义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方为乙方提供车辆保养、维修网点服务。保证合理使用中出现的厂家三包
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                范围内故障维修、具体维修费用及权益和购买新车的售后权益一致。日常使用中因损耗产生的更换小零件、易耗品（如更换刹车片）等由
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方负责。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、车辆外观及人为因素损坏的配件等，由乙方自行承担责任，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方可提供更换维修服务，但更换
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                或维修
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                产生的费用，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                由
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方自行承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '31px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  四、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  套餐
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  费用构成
                </span>
              </strong>
            </p>
            <table>
              <tbody>
                <tr className='firstRow'>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderWidth: '1px',
                      borderColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        车架租金
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTopWidth: '1px',
                      borderTopColor: 'windowtext',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.bikeMoney}
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        &nbsp;
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        电池租金
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.dcMoney}
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        &nbsp;
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        元
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        &nbsp;
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        运营商服务费
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.agentMoney}
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        &nbsp;
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        技术服务费
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.platMoney}
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        &nbsp;
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        免
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        赔
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        服务费（可选）
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  ></td>
                </tr>
                <tr style={{ height: '11px' }}>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        押金（冻结资金）
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  />
                </tr>
                <tr style={{ height: '21px' }}>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        合计
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.packageMoney}
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        &nbsp;
                      </span>
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        元
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  说明：
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、车架租金：乙方租赁车架
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （不含电池）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                产生的租金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                由甲方收取
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、电池租金：乙方租赁电池产生的租金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                由甲方收取
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                服务费：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                收取的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                项目运营、车
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                架、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                电池等资产保管及
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                收发
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                等相关服务费用。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                4、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                技术
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                服务费：甲
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(0, 112, 192)',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  基于互联网，以包含飞熊租赁平台网站、小程序、
                </span>
                APP等在内的各种形态（包括未来技术发展出现的新的服务形态）向乙方提供管理服务工作，包括但不限于发布租赁标的或服务，对租赁标的或服务进行评价管理，对租赁标的进行物联网管控，并妥善处理或协助处理平台上有关的交易纠纷等。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                5、服务费：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                在
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                发生产品丢失后，平台提供物联网寻车定位，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                提供线下协助寻车服务，所产生的的服务费。详见
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              ></span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                服务费收取规定。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                6、押金（冻结资金）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ：乙方在平台上注册以及租赁车辆，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                符合
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                可享受信用
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租服务，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>即乙方在</span>“
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                支付宝
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ”
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                APP上的芝麻信用达到
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                “支付宝”APP的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                审核标准的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，租赁车辆时可不支付押金，若未达到，则需
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                支付
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                押金。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                上述
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                服务费及归属
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              ></span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                服务费，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                授权
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方代为向
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                收取，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                收取的费用所涉及的纳税义务由
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                自行承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  五、租赁期限
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                本合同
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                最低租赁期限为
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                30
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                日（含起租日），
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>且以</span>
                30日为一个租赁单位，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                起租时间和到期时间详见下单页面。如
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                发起续租，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                本协议
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租赁期限
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                自动延长至
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                所选的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                下一个租赁单位
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  六
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  退租
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  条款
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                逾期
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                订单
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                到期之后既
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                未续约
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                又未
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                退租
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                的，视为乙方违约，应承担逾期租金，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                计费方式为逾期后每天
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                每车
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                30
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                元。由
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲方在租赁平台上
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                收取。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                逾期
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                违约金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ：当
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>订单发生超时，</span>
                15天内不进行续租或者退租，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                且不支付逾期
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，则平台代扣冻结资金作为逾期
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                违约金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。如代扣失败，平台有权将违约情况上报蚂蚁金服综合信用平台与中国人民银行征信系统。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  七
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  协议终止或解除
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ．租赁期满，乙方退还租赁
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                车
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                架和锂电池
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，经
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                完成
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                验收
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，协议各方完成结算
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                后，本协议终止。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                .
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                若
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                协议各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方怠于履行本协议约定的各项义务
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                或违反本协议
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                的约定
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，甲方有权单方面宣布解除本协议
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，违约方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  除应承担本协议约定的义务外，还应向各守约方分别支付违约金
                </span>
                1万元
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  八、免责与告知条款
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                1、乙方在甲方平台租赁的车辆由于
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                整备
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                重量
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                、车速等
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                原因
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                ，
              </span>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  存在
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  可能被交通管理部门认定为机动车
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  的风险
                </span>
              </strong>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                ，因此出现交通事故或乙方违反交通法规、政策行驶时，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                存在
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                按照
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                机动车辆承担责任
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                风险
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                。
              </span>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  在此提示乙方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  ：
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  乙方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  申请
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  租赁
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  即
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  视为乙方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  了解并愿意承上述风险，
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  发生
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  交通事故，
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  如需要
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  乙方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  自行承担责任
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  及第三方人身、财产损失赔偿责任由乙方自行承担
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  的，乙方不会因此原因要求甲方承担赔偿责任
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    color: 'rgb(255, 0, 0)',
                    fontSize: '16px',
                  }}
                >
                  。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                2、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                租赁期间，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                由于第三方原因（包括但不限于偷盗、故意毁坏
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                、交通事故
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                等）造成车辆损失的，责任由乙方承担，乙方购买服务的，按照规定执行。
              </span>
            </p>
            <p
              style={{
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '32px',
                background: 'rgb(245, 246, 238)',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                3、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '16px',
                }}
              >
                乙方承担租赁车辆交通事故车辆损失、车辆盗抢、第三者责任的意外风险。
              </span>
            </p>
            <p
              style={{
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '32px',
                background: 'rgb(245, 246, 238)',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  color: 'rgb(67, 67, 67)',
                  fontSize: '16px',
                }}
              >
                4
              </span>
              <span
                style={{
                  fontFamily: '"Microsoft YaHei"',
                  color: 'rgb(67, 67, 67)',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  、乙方自愿向保险公司投保或其它方式承担意外风险，甲方不得干涉乙方意愿。
                </span>
              </span>
            </p>
            <p
              style={{
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '32px',
                background: 'rgb(245, 246, 238)',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  color: 'rgb(67, 67, 67)',
                  fontSize: '16px',
                }}
              >
                5
              </span>
              <span
                style={{
                  fontFamily: '"Microsoft YaHei"',
                  color: 'rgb(67, 67, 67)',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  、上述风险损失的计算、赔付依照保险及赔付程序进行均有乙方自行处理，偿付甲方车辆损失。
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  九、不可抗力
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                本合同所指的不可抗力，是指不能预见、不能避免并不能克服的客观情况，包括但不限于：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  letterSpacing: '1px',
                  fontSize: '16px',
                }}
              >
                法律法规、规章、政策等规定的变更、新颁布等
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                自然灾害、地震、洪水、雷击、火灾、战争或准战争状态、恐怖活动、戒严等不可抗力事件，合同生效后，合同任何一方由于不可抗力事件而影响到本合同履行时，则延长履行合同期限或解除合同，这一期限相当于事故所影响的时间，并可根据情况部分或全部免予承担违约责任，但一方延迟履约后发生不可抗力的，不能免除责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  <span style={{ fontFamily: 'SimSun' }}>十、其他约定</span>
                  &nbsp;&nbsp;
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、本协议一式
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                三
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                份，各方各执一份，自各方签字盖章
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （含电子签章）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                之日起生效
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                若电子签订，不再
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                签订书面合同
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、如有异议经双方协商可另行签订补充合同或条款,补充合同或条款与本合同具同等法律效力
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方履行本协议过程中出现争议与纠纷应友好协商，协商不成的，均可向甲方所在地人民法院起诉。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                4、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方确认各自的联系信息分别如下所示，并且
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方应保持各自联系信息的持续性和有效性，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                因下述联系信息不准确、变更后未通知造成无法送达的，责任由接收方承担；如有变更，变更方应当及时通知其他方，变更通知到达其他方之前，其他方按约定地址和联系人发送的通知均视为送达。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                以下无正文
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （盖章）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                代理人（签字）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                签字
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （盖章）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                代理人（签字）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>合同签订时间：</span>
                &nbsp;&nbsp;<span style={{ fontFamily: 'SimSun' }}>年</span>
                &nbsp;&nbsp;<span style={{ fontFamily: 'SimSun' }}>月</span>
                &nbsp;&nbsp;<span style={{ fontFamily: 'SimSun' }}>日</span>
              </span>
            </p>
          </div>
        )}
        {this.state.id === 'leaseContractFZY' && (
          <div id='leaseContractFZY'>
            <p
              style={{
                fontSize: 'medium',
                whiteSpace: 'normal',
                textAlign: 'justify',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    color: 'rgb(51, 51, 51)',
                    fontSize: '16px',
                  }}
                >
                  <span style={{ fontFamily: 'SimSun' }}>合同版本号：</span>
                  ZL-2020-
                  <br />
                  合同编码：YM-
                </span>
              </strong>
            </p>
            <h1
              style={{
                marginTop: '23px',
                marginBottom: '22px',
                breakAfter: 'avoid',
                textAlign: 'center',
                lineHeight: '70.4px',
                fontFamily: 'Calibri',
                fontSize: '29px',
                whiteSpace: 'normal',
              }}
            >
              <strong>
                <span style={{ fontFamily: 'SimSun', fontSize: '29px' }}>飞熊租赁用户服务合同</span>
              </strong>
            </h1>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontFamily: 'SimSun', fontSize: '14px' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  color: 'rgb(255, 0, 0)',
                  fontSize: '21px',
                }}
              >
                （非自营）
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  甲方（平台方）：杭州蚁租网络科技有限公司
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  社会信用代码：{orderData?.platform.taxNo}
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  乙方（承租方）：{orderData?.userInfo.userName}
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>身份证号：{orderData?.userInfo.cardNo}</span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>联系电话：{orderData?.userInfo.mobile}</span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙方（
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  商）：{orderData?.franchise.companyName}
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  社会信用代码：{orderData?.franchise.taxNo}
                </span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丁一方（车架出租方）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>社会信用代码：</span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丁二方（电池出租方）：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>社会信用代码：</span>
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                根据《中华人民共和国合同法》等相关法律法规的规定，明确甲方（出租方）与乙方（承租方）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                及其他各方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                权利义务关系。经双方协商一致，签订本合同。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                特别提醒：在承租方（本协议中称乙方）确认同意本协议之前，承租方应已清楚知悉并充分理解本产品的所有信息，同意向平台方即杭州蚁租网络科技有限公司（本协议中称甲方）申请提供租赁管理服务。一旦承租方接受本协议，即视为承租方已阅读本协议所有条款，并对本协议条款的含义及相应的法律后果已全部通晓并充分理解，同意接受本协议约束。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                为了维护承租方的合法权益，特别提醒承租方关注本协议条款，请务必仔细阅读本协议条款。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各方确认并承诺：租赁过程中填写的名称、联系方式、证件信息等准确无误，通过上述地址寄送的任何文书均视为已收到该文书。对于因本协议争议引起的任何纠纷，各方声明司法机关（包括但不限于人民法院）可以手机短信或电子邮件等现代通讯方式或邮寄方式送达法律文书（包括但不限于诉讼文书）。如有变更，将重新签署地址变更确认书并书面通知。各方承担因按照上述地址投递或变更地址而导致无法收到文书所引起的任何法律责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方确认并承诺：使用以乙方本人名义注册的且经过实名认证的个人账户在甲方平台（含甲方相关客户端，下同）所从事的所有行为均视为乙方本人行为，包括但不限于订立本协议、申请租赁服务等，该等行为的法律后果均由乙方本人承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  租赁标的：车架：
                </span>
              </strong>
              <strong>
                <span style={{ textDecoration: 'underline' }}>
                  <span
                    style={{
                      fontFamily: 'SimSun',
                      lineHeight: '24px',
                      fontSize: '16px',
                    }}
                  >
                    &nbsp;{orderData?.orderInfo.bikeModelName}&nbsp;
                  </span>
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  <span style={{ fontFamily: 'SimSun' }}>，电池：</span>
                </span>
              </strong>
              <strong>
                <span style={{ textDecoration: 'underline' }}>
                  <span
                    style={{
                      fontFamily: 'SimSun',
                      lineHeight: '24px',
                      fontSize: '16px',
                    }}
                  >
                    &nbsp;{orderData?.orderInfo.dcModelName}&nbsp;
                  </span>
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  （如有品牌编号的，填写品牌编号）
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  一、甲方权利与义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、甲方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  基于互联网，以包含飞熊租赁平台网站、小程序、
                </span>
                APP等在内的各种形态（包括未来技术发展出现的新的服务形态）向客户提供管理服务工作，包括但不限于发布租赁标的或服务，对租赁标的或服务进行评价管理，对租赁标的进行物联网管控，并妥善处理或协助处理平台上有关的交易纠纷等。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、
              </span>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  甲
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  方并非租赁物出租方，不承担由乙方使用租赁车辆引发的连带责任和乙方使用过程中人员交通意外损害赔偿责任及本合同规定的风险赔付范围之外的任何经济责任。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  二、乙方的权利和义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、认真的检查并掌握租赁车辆的各种性能和操作方法，点清随车配置的附件，验收签字后驶离。凡因乙方操作不当、保管不善造成的车架、锂电池遗失或附件损坏，乙方应按照本合同约定（未约定的按照市场价）向
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                赔偿。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、乙方使用租赁车辆过程中发生的交通事故及其他安全事故造成乙方或第三人人身或财产损害的所有责任均由乙方自行承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、乙方租赁期间发生车架、电池、或配件盗抢、丢失、损毁、灭失的，乙方应
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                向出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>承担赔偿责任。车架按</span>
                2000元/辆（不含电池）；电池如果发生丢失，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                锂电池
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>按</span>
                4000元/组赔偿，锂电池充电器按380元赔偿
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                4、乙方租赁期间可以在飞熊租赁小程序上购买丢车服务，服务费为每年90元，乙方购买该服务后，如租赁期间发生车架丢失，乙方提供报案证明即无需承担丢失车架损失，如租赁期间锂电池丢失的，丢失的锂电池额为3000元/组，即乙方按1000元/组进行赔偿。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                5、乙方禁止打开电池盒，如发现私自打开电池盒更换电池行为，每次每组电池按600元向
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                支付违约金。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                6
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                按照本协议约定及时
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                向出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                足额支付租赁费用，合理使用租赁车辆﹙除另有约定外﹚，租赁车辆的合理使用指以满足乙方使用需要的驾驶使用。费用
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                为按月收取，如乙方未到期进行退租，则
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                视为乙方自动放弃剩余使用期限，所付费用不予退还。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                7、使用租赁车辆应遵守相关法律、法规、规章、政策等，因违法、违规、违章所引起的刑事、民事、行政责任，均由乙方自行负责。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                8、乙方必须按照约定的时间、地点归还车辆，还车时必须保证车辆性能良好、电池满电、车辆整洁、设备齐全，并无任何刮碰现象，否则乙方应按照本协议约定向
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                赔偿。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                9、乙方不得私配出租车辆的钥匙。若造成车辆丢失、损坏等情况必须立即通知甲方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                及出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，并向
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                赔偿车辆损失及修配所租车辆门锁和点火开关等车辆配件的费用。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                10、不得私自组装、改装、拆卸、更换租赁车辆的零部件，亦不得在租赁车辆上增加任何组件或配件骑行，若乙方违反本协议约定而造成任何自身或第三人人身或财产损害的，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                不承担任何责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                11、不得买卖、抵押、质押、转租、转借租赁车辆；不得擅自变动、修理、添改租赁车辆任何部位或部件。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                12、保证租赁车辆为合同登记的承租人驾驶，不得随意变更实际使用人。在合同期内，如乙方登记的信息发生变化，应及时通知甲方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                及出租方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，否则发生任何事务责任，将由乙方承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  三
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  丙
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  方的权利和义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方为乙方提供车辆保养、维修网点服务。保证合理使用中出现的厂家三包范围内故障维修、具体维修费用及权益和购买新车的售后权益一致。日常使用中因损耗产生的更换小零件、易耗品（如更换刹车片）等由
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方负责。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、车辆外观及人为因素损坏的配件等，由乙方自行承担责任，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方可提供更换维修服务，但更换过程中所产生的零件等费用，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                由
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方自行承担。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方不承担由乙方使用租赁车辆引发的连带责任和乙方使用过程中人员交通意外损害赔偿责任及本合同规定的风险赔付范围之外的任何经济责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  四、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  丁一
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  方的权利和义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丁一方拥有车架的所有权，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                作为车架的出租方，应当提供合格产品，承担相应责任，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                并享有车架租金的收益。
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                具体租赁权利义务由丁一方与乙方另行补充
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  五、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  丁二
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  方的权利和义务
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丁二方拥有电池的所有权，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                作为电池的出租方，应当提供合格产品，承担相应责任，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                并享有
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                电池
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租金的收益。
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                具体租赁权利义务由丁二方与乙方另行补充
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '31px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  六、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  套餐
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  费用构成
                </span>
              </strong>
            </p>
            <table>
              <tbody>
                <tr className='firstRow'>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderWidth: '1px',
                      borderColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        车架租金
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTopWidth: '1px',
                      borderTopColor: 'windowtext',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.bikeMoney} 元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        电池租金
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.dcMoney} 元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        运营商服务费
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.agentMoney} 元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        技术服务费
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.platMoney} 元
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        免责服务费（可选）
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  ></td>
                </tr>
                <tr>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeftWidth: '1px',
                      borderLeftColor: 'windowtext',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        合计
                      </span>
                    </p>
                  </td>
                  <td
                    width={284}
                    valign='top'
                    style={{
                      padding: '0px 7px',
                      borderLeft: 'none',
                      borderRightWidth: '1px',
                      borderRightColor: 'windowtext',
                      borderTop: 'none',
                      borderBottomWidth: '1px',
                      borderBottomColor: 'windowtext',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'justify',
                        fontFamily: 'Calibri',
                        fontSize: '14px',
                        textIndent: '32px',
                        lineHeight: '21px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'SimSun',
                          lineHeight: '24px',
                          fontSize: '16px',
                        }}
                      >
                        {orderData?.orderInfo.packageMoney} 元
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                说明：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                车架租金：用户租赁车架
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （不含电池）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                产生的租金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、电池租金：用户租赁电池产生的租金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                运营商
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                服务费：运营商收取的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                项目运营、车辆电池等资产保管及
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                收发
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                等相关服务费用。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                4、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                技术
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                服务费：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                平台方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>
                  基于互联网，以包含飞熊租赁平台网站、小程序、
                </span>
                APP等在内的各种形态（包括未来技术发展出现的新的服务形态）向客户提供管理服务工作，包括但不限于发布租赁标的或服务，对租赁标的或服务进行评价管理，对租赁标的进行物联网管控，并妥善处理或协助处理平台上有关的交易纠纷等。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                5、免责服务费：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                在用户发生产品丢失后，平台提供物联网寻车定位，运营商提供线下协助寻车服务，所产生的的服务费。详见免责服务费收取规定。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  上述运营商
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  出租方的
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  服务费、归属运营商
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  出租方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  的租金及免责服务费
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  等费用
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  ，运营商
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  或出租方
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  授权平台方代为向用户收取，收取的费用所涉及的纳税义务由
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  纳税主体
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  自行承担。
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  七、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  协议有效期
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                本合同
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                最低租赁期限为
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                30
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                日（含起租日），
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>且以</span>
                30日为一个租赁单位，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                起租时间和到期时间详见下单页面。如
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                发起续租，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                本协议
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                租赁期限
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                自动延长至
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                所选的
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                下一个租赁单位
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                如出租方与乙方另行约定租期的，应当告知甲方，否则，甲方不承担相应责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  八、
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  违约条款
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                逾期违约金：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                用户
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                订单
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                到期之后
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                未续约或退租，因此而
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                违约
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                后所
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                产生的逾期违约金
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>。计费方式为逾期后每天</span>
                30元。
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                由甲方代收。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>逾期罚款：当用户订单发生超时，</span>
                15天内不进行续租或者退租，且不支付逾期违约金，则平台代扣冻结资金作为逾期罚款。如代扣失败，平台有权将违约情况上报蚂蚁金服综合信用平台与中国人民银行征信系统。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  九
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、不可抗力
                </span>
              </strong>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                本合同所指的不可抗力，是指不能预见、不能避免并不能克服的客观情况，包括但不限于：法律法规、规章、政策等规定的变更、新颁布等自然灾害、地震、洪水、雷击、火灾、战争或准战争状态、恐怖活动、戒严等不可抗力事件，合同生效后，合同任何一方由于不可抗力事件而影响到本合同履行时，则延长履行合同期限或解除合同，这一期限相当于事故所影响的时间，并可根据情况部分或全部免予承担违约责任，但一方延迟履约后发生不可抗力的，不能免除责任。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  十
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    fontFamily: 'SimSun',
                    lineHeight: '24px',
                    fontSize: '16px',
                  }}
                >
                  、其他约定
                </span>
              </strong>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;&nbsp;&nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                1、本协议一式
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                五
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                份，各方各执一份，自各方签字盖章（含电子签章）之日起生效
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                若电子签订，不再签订书面合同
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                2、如有异议经双方协商可另行签订补充合同或条款,补充合同或条款与本合同具同等法律效力
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                3、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方履行本协议过程中出现争议与纠纷应友好协商，协商不成的，均可向甲方所在地人民法院起诉。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                4、
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方确认各自的联系信息分别如下所示，并且
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                各
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方应保持各自联系信息的持续性和有效性，
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                因下述联系信息不准确、变更后未通知造成无法送达的，责任由接收方承担；如有变更，变更方应当及时通知其他方，变更通知到达其他方之前，其他方按约定地址和联系人发送的通知均视为送达。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                （
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                以下无正文
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                ）。
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                甲方
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                名称：杭州蚁租网络科技有限公司
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                签章：
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>联系电话：</span>
                400-081-1818
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                乙方
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                名称：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丙
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                名称：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丁一
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                名称：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                丁二
              </span>
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                方
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                名称：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系电话：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                联系地址：
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                textIndent: 0,
                whiteSpace: 'normal',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              style={{
                textAlign: 'justify',
                fontFamily: 'Calibri',
                fontSize: '14px',
                textIndent: '0px',
                whiteSpace: 'normal',
                lineHeight: '21px',
              }}
            >
              <span
                style={{
                  fontFamily: 'SimSun',
                  lineHeight: '24px',
                  fontSize: '16px',
                }}
              >
                <span style={{ fontFamily: 'SimSun' }}>合同签订时间：</span>
                &nbsp;&nbsp;<span style={{ fontFamily: 'SimSun' }}>年</span>
                &nbsp;&nbsp;<span style={{ fontFamily: 'SimSun' }}>月</span>
                &nbsp;&nbsp;<span style={{ fontFamily: 'SimSun' }}>日</span>
              </span>
            </p>
          </div>
        )}
        {this.state.id === 'saleContract' && (
          <div id='saleContract'>
            <p
              style={{
                margin: '3px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>合同版本号：</span>ZL-
              </span>
              &nbsp;
            </p>
            <p
              style={{
                margin: '3px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>合同编码：</span>YM-
              </span>
            </p>
            <p
              style={{
                margin: '7px 242px 0 241px',
                textAlign: 'center',
                fontFamily: '宋体',
                fontSize: '15px',
                textIndent: 0,
              }}
            >
              <span style={{ fontSize: '21px' }}>购车合同</span>
            </p>
            <p
              style={{
                margin: '12px 231px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>甲方</span>(平台方)：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </span>

              <span style={{ textDecoration: 'underline' }}>杭州蚁租网络科技有限公司</span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </span>
            </p>
            <p
              style={{
                margin: '12px 231px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>社会信用代码：</span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    <span style={{ fontFamily: '"Times New Roman"' }}>
                      {orderData?.platform.taxNo}
                    </span>
                  </span>
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    &nbsp;
                  </span>
                </span>
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '13px' }}>&nbsp;</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '19px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '5px 247px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>乙方</span>(购车方)：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                </span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    <span style={{ fontFamily: '"Times New Roman"' }}>
                      {orderData?.userInfo.userName}
                    </span>
                  </span>
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    &nbsp;
                  </span>
                </span>
              </span>
            </p>
            <p
              style={{
                margin: '5px 247px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>身份证号：</span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  &nbsp;
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    <span style={{ fontFamily: '"Times New Roman"' }}>
                      {orderData?.userInfo.cardNo}
                    </span>
                  </span>
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    &nbsp;
                  </span>
                </span>
              </span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>联系电话：</span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    <span style={{ fontFamily: '"Times New Roman"' }}>
                      &nbsp;{orderData?.userInfo.mobile}&nbsp;
                    </span>
                  </span>
                </span>
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '13px' }}>&nbsp;</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '13px' }}>&nbsp;</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '14px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 231px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '20px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>丙方</span>(运营商)：
              </span>
              <span style={{ textDecoration: 'underline' }}>
                &nbsp;{orderData?.franchise.companyName}&nbsp;
              </span>
            </p>
            <p
              style={{
                margin: '0 231px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '20px',
              }}
            >
              <span style={{ fontSize: '16px' }}>社会信用代码：</span>
              <span style={{ textDecoration: 'underline' }}>
                <span
                  style={{
                    fontFamily: '"Times New Roman"',
                    fontSize: '16px',
                  }}
                >
                  <span
                    style={{
                      fontFamily: '宋体',
                      textDecorationLine: 'underline',
                    }}
                  >
                    <span style={{ fontFamily: '"Times New Roman"' }}>
                      &nbsp;{orderData?.franchise.taxNo}&nbsp;
                    </span>
                  </span>
                </span>
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '13px' }}>&nbsp;</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontFamily: '"Times New Roman"', fontSize: '19px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '5px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>合同时间：</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>期免息，自</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>年</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>月</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>日</span>
                <span style={{ fontFamily: '宋体' }}>至</span>
              </span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>年</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>月</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>日</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '17px' }}>&nbsp;</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '15px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                根据《中华人民共和国民法典》及有关规定，甲乙丙三方经协商，自愿达成如下
              </span>
              <span style={{ fontSize: '16px' }}>购车合同。</span>
            </p>
            <p
              style={{
                margin: '10px 16px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>
                  乙方确认并承诺：使用以乙方本人名义注册的且经过实名认证的个人账户在甲方平台（含甲方相关客户端，下同）所从事的所有行为均视为乙方本人行为，
                </span>
                <span style={{ fontFamily: '宋体' }}>
                  包括但不限于订立本协议、申请购车服务等，该等行为的法律后果均由乙方本人承担。
                </span>
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>第一条&nbsp;</span>
                <span style={{ fontFamily: '宋体' }}>商品买卖</span>
              </span>
            </p>
            <p
              style={{
                margin: '8px 9px 0 36px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                乙方可通过银行信用卡的形式购买丙方通过甲方平台销售的电动自行车。
              </span>
            </p>
            <p
              style={{
                margin: '0 6px 0 36px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                乙方同意授权甲方查询乙方信用情况，以便甲方接受乙方通过甲方平台以银行信用卡的付款方式购买丙方商品。
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '12px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>第二条&nbsp;</span>
                <span style={{ fontFamily: '宋体' }}>标的物，数量，价款及付款方式</span>
              </span>
            </p>
            <p
              style={{
                margin: '5px 0 0 40px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>1、本合同的标的物为型号“</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>”的电动车，数量</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>辆。</span>
            </p>
            <p
              style={{
                margin: '6px 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                2、甲方收到乙方提交的购车订单后，代乙方向丙方支付购车款。车价款
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>总</span>
              <span style={{ fontSize: '16px' }}>额为人民币</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ fontSize: '16px' }}>
                元整。乙方通过银行信用卡向甲方支付车价款。除购
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>车</span>
            </p>
            <p>
              <span style={{ fontFamily: '宋体', fontSize: '16px' }}>
                <br />
              </span>
            </p>
            <p
              style={{
                margin: '3px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                款外，根据不同免息期数，甲方收取不同比例的运营服务费，具体如下：
              </span>
            </p>
            <p
              style={{
                margin: '11px 0 0 40px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                ①三期免息：平台收取车价款总额的
              </span>
              <span style={{ fontSize: '16px' }}>6%；</span>
            </p>
            <p
              style={{
                margin: '11px 0 0 40px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                ②六期免息：平台收取车价款总额的
              </span>
              <span style={{ fontSize: '16px' }}>9%；</span>
            </p>
            <p
              style={{
                margin: '11px 187px 0 40px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24.32px',
              }}
            >
              <span style={{ fontSize: '16px' }}>③十二期免息：平台收取车价款总额的 &nbsp;</span>
              <span style={{ letterSpacing: 0, fontSize: '16px' }}>&nbsp;</span>
              <span style={{ fontSize: '16px' }}>15%； 3、车辆交付地点：</span>
              <span style={{ textDecoration: 'underline' }}>
                <span style={{ fontSize: '16px' }}>&nbsp;</span>
              </span>
              <span style={{ textDecoration: 'underline' }}> </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>。</span>
            </p>
            <p
              style={{
                margin: '10px 9px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>4</span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                、丙方向乙方提供的车辆，其质量应符合国家电动自行车产品标准或行业
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                标准，并符合出厂检验标准，符合安全驾驶和说明书载明的基本使用要求，符合
              </span>
              <span style={{ fontSize: '16px' }}>车辆落籍地政府相关政策。</span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '11px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>第三条&nbsp;</span>
              <span style={{ fontSize: '16px' }}>甲方的权利和义务</span>
            </p>
            <p
              style={{
                margin: '13px 7px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '48px',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>1</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                、甲方基于互联网，包含以云马租车平台网站、小程序、
              </span>
              <span style={{ fontSize: '16px' }}>APP</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                &nbsp;<span style={{ fontFamily: '宋体' }}>等在内的</span>
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>各种形态</span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>（</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                包括未来技术发展出现的新的服务形态
              </span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>）</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>向客户提供管理服务工作，</span>
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>
                  包括但不限于发布销售标的或服务，对销售标的或服务进行评价管理，协助丙方
                </span>
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                对销售标的进行物联网管控，并妥善处理或协助处理平台上有关的交易纠纷等。
              </span>
            </p>
            <p
              style={{
                margin: '2px 22px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '15px',
                textIndent: '48px',
                lineHeight: '22px',
              }}
            >
              <strong>
                <span style={{ lineHeight: '24px', fontSize: '16px' }}>2</span>
              </strong>
              <strong>
                <span
                  style={{
                    lineHeight: '24px',
                    letterSpacing: -0,
                    fontSize: '16px',
                  }}
                >
                  、甲方并非车辆售卖方，不承担由乙方使用车辆引发的责任和乙方使
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    lineHeight: '24px',
                    letterSpacing: '1px',
                    fontSize: '16px',
                  }}
                >
                  <span style={{ fontFamily: '宋体' }}>
                    用过程中人员交通意外损害赔偿责任及本合同规定的风险赔付范围之外的
                  </span>
                  &nbsp;
                </span>
              </strong>
              <strong>
                <span
                  style={{
                    lineHeight: '24px',
                    letterSpacing: '1px',
                    fontSize: '16px',
                  }}
                >
                  任何经济责任。
                </span>
              </strong>
            </p>
            <p
              style={{
                margin: '1px 0 0',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <strong>
                <span style={{ fontSize: '20px' }}>&nbsp;</span>
              </strong>
            </p>
            <p
              style={{
                margin: '0 43px 0 40px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '20px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>第四条&nbsp;</span>
                <span style={{ fontFamily: '宋体' }}>乙方的权利和义务</span>
              </span>
            </p>
            <p
              style={{
                margin: '5px 9px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                1、支付车价款总额及相应的运营服务费后，车辆所属权归乙方所有。
              </span>
            </p>
            <p
              style={{
                margin: '5px 9px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                2、乙方已确认所购车辆的质量状况并同意购买。乙方对所对所购车辆在使
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                用期间出现的质量问题，应由丙方负责处理，乙方不能以此作为拖欠支付甲方车
              </span>
              <span style={{ fontSize: '16px' }}>辆款及运营服务费的理由。</span>
            </p>
            <p
              style={{
                margin: '0 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                3、本合同涉及的全部款项(含逾期租金违约金)全部结清前，乙方不得将所购车辆自行转让、销售、出租、抵押、偿债。
              </span>
            </p>
            <p
              style={{
                margin: '0 9px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>4</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>、当乙方客观上有危及所欠车款安全情况时</span>
                (包括涉及经济纠纷的诉讼、交
              </span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>通责任事故、经济状况恶化等</span>
                )应当在时间发生后三天内书面通知甲方，并保证
              </span>
              <span style={{ fontSize: '16px' }}>所欠甲方车款本息的全部偿还。</span>
            </p>
            <p
              style={{
                margin: '0 0 0 40px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                5、乙方可在飞熊租赁小程序上购买丢车服务。若购买该服务，保险期
              </span>
            </p>
            <p>
              <span
                style={{
                  fontFamily: '宋体',
                  letterSpacing: -0,
                  fontSize: '16px',
                }}
              >
                <br />
              </span>
            </p>
            <p
              style={{
                margin: '3px 9px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                限为自本合同签订之日起至乙方最后还款日止。如发生全车失窃、报损或其他形
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                式的灭失，乙方必须继续履行合同的义务，并要将保险公司的保险赔付用于一次
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                性偿还所欠甲方的款项，乙方同意由保险公司直接支付给甲方。其中车辆灭失的
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>损失，保险公司理赔不足部分由乙方承担</span>
                (含保险公司不予理赔的车辆损失)。乙
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                方在车辆使用过程中，致使第三者造成人身伤亡或财产损坏，由乙方负责承担全
              </span>
              <span style={{ fontSize: '16px' }}>部赔偿责任。</span>
            </p>
            <p
              style={{
                margin: '1px 0 0',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '12px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>第五条&nbsp;</span>
              <span style={{ fontSize: '16px' }}>丙方的权利和义务</span>
            </p>
            <p
              style={{
                margin: '5px 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                1、在本合同有效期内，下述情况发生时，丙方有权随时随地收回车辆和对车辆做任何处理，已收取的款项不予退回。
              </span>
            </p>
            <p
              style={{
                margin: '0 0 0 40px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>①乙方利用所购车辆从事违法犯罪活动。</span>
            </p>
            <p
              style={{
                margin: '11px 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                ②乙方在本合同有效期内，未付清购车款及运营服务费之前，将所购车辆转
              </span>
              <span style={{ fontSize: '16px' }}>让、转售、转租、抵押、偿债。</span>
            </p>
            <p
              style={{
                margin: '0 0 0 40px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>③乙方拖欠甲方购车款或运营服务费。</span>
            </p>
            <p
              style={{
                margin: '11px 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                2、丙方不承担由乙方使用租赁车辆引发的连带责任和乙方使用过程中人员交通意外损害赔偿责任及本合同规定的风险赔付范围之外的任何经济责任。
              </span>
            </p>
            <p
              style={{
                margin: '0 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                3、在乙方缴纳车款、保险费，签订此销售合同后，丙方应按双方约定将车辆交付至乙方。
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '11px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>第六条</span>
              <span style={{ fontSize: '16px' }}>违约责任</span>
            </p>
            <p
              style={{
                margin: '11px 9px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
                lineHeight: '24.16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                1、任何一方违反本合同规定均应承担违约责任(除不可抗力外)，均应向另一方支付合同总金额
                5%的违约金。
              </span>
            </p>
            <p
              style={{
                margin: '0 0 0 40px',
                fontFamily: '宋体',
                fontSize: '16px',
                lineHeight: '15px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                2、乙方逾期向甲方支付购车款或运营服务费的，每逾期一天，应向甲方支
              </span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>付逾期款项万分之三的违约金。</span>
            </p>
            <p
              style={{
                margin: '1px 0 0',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>第七条&nbsp;</span>
                <span style={{ fontFamily: '宋体' }}>合同的变更和解除</span>
              </span>
            </p>
            <p
              style={{
                margin: '0 9px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '32px',
              }}
            >
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                本合同一经签订，甲乙丙三方均不得单方面变更、解约或退货，对本合同内
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                容的任何修改、补充或变更，必须经三方签署书面协议方能有效。乙方付清全部
              </span>
              <span style={{ fontSize: '16px' }}>
                购车款本息、运营服务费和可能发生的逾期租金违约金、违约金后，本合同自动失效。
              </span>
            </p>
            <p style={{ fontFamily: '宋体', fontSize: '16px' }}>
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '11px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
              }}
            >
              <span style={{ fontSize: '16px' }}>第八条&nbsp;</span>
              <span style={{ fontSize: '16px' }}>其他约定</span>
            </p>
            <p
              style={{
                margin: '11px 40px 0 16px',
                fontFamily: '宋体',
                fontSize: '16px',
                textIndent: '23px',
                lineHeight: '21.92px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>1</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                、本合同一式五份，各方各执一份，自各方签字盖章
              </span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>（</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>含电子签章</span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>）</span>
              <span style={{ fontSize: '16px' }}>之</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                日起生效（若电子签订，不再签订书面合同）
              </span>
              <span style={{ fontSize: '16px' }}>。</span>
            </p>
            <p>
              <span
                style={{
                  fontFamily: '宋体',
                  letterSpacing: -0,
                  fontSize: '16px',
                }}
              >
                <br />
              </span>
            </p>
            <p
              style={{
                margin: '3px 23px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
                textIndent: '31px',
                lineHeight: '24px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>2</span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>
                  、如有异议经双方协商可另行签订补充合同或条款
                </span>
                ,补充合同或条款与本合同具同等法律效力
              </span>
            </p>
            <p
              style={{
                margin: '2px 23px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                3、各方履行本协议过程中出现争议与纠纷应友好协商，协商不成的，均可向甲方所在地人民法院起诉。
              </span>
            </p>
            <p
              style={{
                margin: '2px 16px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
                textIndent: '32px',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                4、各方确认各自的联系信息分别如下所示，并且各方应保持各自联系信
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>
                  息的持续性和有效性，因下述联系信息不准确、变更后未通知造成无法送达的，
                </span>
              </span>
              <span style={{ letterSpacing: '-1px', fontSize: '16px' }}>
                责任由接收方承担；如有变更，变更方应当及时通知其他方，变更通知到达其他
              </span>
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                方之前，其他方按约定地址和联系人发送的通知均视为送达。
              </span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '15px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 291px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                甲方名称：杭州蚁租网络科技有限公司
                <br />
                签章：
              </span>
            </p>
            <p
              style={{
                margin: '0 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>联系电话：</span>
                400-081-1818
              </span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '1px 0 0',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '0 483px 0 8px',
                textAlign: 'justify',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
                lineHeight: '24px',
              }}
            >
              <span style={{ fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>乙方名称：</span>
                <br />
                <span style={{ fontFamily: '宋体' }}>联系电话：</span>
                <br />
                <span style={{ fontFamily: '宋体' }}>联系地址</span>
              </span>
            </p>
            <p
              style={{
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>&nbsp;</span>
            </p>
            <p
              style={{
                margin: '11px 483px 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
                lineHeight: '20.32px',
              }}
            >
              <span style={{ letterSpacing: -0, fontSize: '16px' }}>
                <span style={{ fontFamily: '宋体' }}>丙方名称：</span>
                <br />
                <span style={{ fontFamily: '宋体' }}>联系电话：</span>
                <br />
                <span style={{ fontFamily: '宋体' }}>联系地址：</span>
              </span>
            </p>
            <p
              style={{
                margin: '12px 0 0 8px',
                fontFamily: '宋体',
                fontSize: '16px',
                whiteSpace: 'normal',
              }}
            >
              <span style={{ fontSize: '16px' }}>合同签订时间：</span>
            </p>
            <p></p>
          </div>
        )}
      </div>
    )
  }
  componentDidMount() {}
}
export default Terms
